webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuexRouterSync = __webpack_require__(332);
	
	var _store = __webpack_require__(69);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(140);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _upperFirst = __webpack_require__(95);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _camelCase = __webpack_require__(279);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _buefy = __webpack_require__(167);
	
	var _buefy2 = _interopRequireDefault(_buefy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_buefy2.default);
	
	var requireComponent = __webpack_require__(334);
	
	requireComponent.keys().forEach(function (fileName) {
	  var componentConfig = requireComponent(fileName);
	
	  var componentName = (0, _upperFirst2.default)((0, _camelCase2.default)(fileName.replace(/^\.\/(.*)\.\w+$/, "$1")));
	
	  _vue2.default.component(componentName, componentConfig.default || componentConfig);
	});
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	new _vue2.default({
	  router: _router2.default,
	  store: _store2.default
	}).$mount("#app");

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(101);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Kithara = function () {
	  function Kithara() {
	    (0, _classCallCheck3.default)(this, Kithara);
	  }
	
	  (0, _createClass3.default)(Kithara, [{
	    key: "getHTTP",
	    value: function getHTTP() {
	      return _axios2.default.create({
	        baseURL: "api",
	        headers: {
	          Authorization: "Bearer " + localStorage.getItem("kithara.token")
	        }
	      });
	    }
	  }, {
	    key: "login",
	    value: function login(username, password) {
	      return this.getHTTP().post("/v1/auth", {
	        username: username,
	        password: password
	      });
	    }
	  }, {
	    key: "getSongs",
	    value: function getSongs(page, perPage, sort, filters) {
	      var tags = filters.tags.join("+");
	      return this.getHTTP().get("/v2/song-versions", {
	        params: {
	          page: page,
	          per_page: perPage,
	          sort: sort,
	          filter: filters.main,
	          tags: tags
	        }
	      });
	    }
	  }, {
	    key: "getTeamSongs",
	    value: function getTeamSongs(team, page, perPage, sort, filters) {
	      var tags = filters.tags.join("+");
	      return this.getHTTP().get("/v2/teams/" + team + "/song-versions", {
	        params: {
	          page: page,
	          per_page: perPage,
	          sort: sort,
	          filter: filters.main,
	          tags: tags
	        }
	      });
	    }
	  }, {
	    key: "getSong",
	    value: function getSong(id) {
	      return this.getHTTP().get("/v2/song-versions/" + id);
	    }
	  }, {
	    key: "createSong",
	    value: function createSong(data) {
	      var tags = data.song && data.song.tags ? data.song.tags : [];
	      data["translator"] = { id: 1, name: "whatever" };
	      data["language"] = { id: 1, name: "whatever" };
	      data["song"] = {
	        composer: { id: 1, name: "whatever" },
	        tags: tags
	      };
	      return this.getHTTP().post("/v2/song-versions", data);
	    }
	  }, {
	    key: "updateSong",
	    value: function updateSong(id, data) {
	      return this.getHTTP().put("/v2/song-versions/" + id, data);
	    }
	  }, {
	    key: "deleteSong",
	    value: function deleteSong(id) {
	      return this.getHTTP().delete("/v2/song-versions/" + id);
	    }
	  }, {
	    key: "getPlaylists",
	    value: function getPlaylists(page, perPage, sort, filter) {
	      return this.getHTTP().get("/v2/playlists", {
	        params: {
	          page: page,
	          per_page: perPage,
	          sort: sort,
	          filter: filter
	        }
	      });
	    }
	  }, {
	    key: "getPlaylist",
	    value: function getPlaylist(id) {
	      return this.getHTTP().get("/v2/playlists/" + id);
	    }
	  }, {
	    key: "createPlaylist",
	    value: function createPlaylist(data) {
	      return this.getHTTP().post("/v2/playlists", data);
	    }
	  }, {
	    key: "updatePlaylist",
	    value: function updatePlaylist(id, data) {
	      return this.getHTTP().put("/v2/playlists/" + id, data);
	    }
	  }, {
	    key: "deletePlaylist",
	    value: function deletePlaylist(id) {
	      return this.getHTTP().delete("/v2/playlists/" + id);
	    }
	  }, {
	    key: "getPlaylistItems",
	    value: function getPlaylistItems(playlistId, page, perPage, sort, filter) {
	      return this.getHTTP().get("/v2/playlists/" + playlistId + "/items", {
	        params: {
	          page: page,
	          per_page: perPage,
	          sort: sort,
	          filter: filter
	        }
	      });
	    }
	  }, {
	    key: "getPlaylistItem",
	    value: function getPlaylistItem(playlistId, itemId) {
	      return this.getHTTP().get("/v2/playlists/" + playlistId + "/items/" + itemId);
	    }
	  }, {
	    key: "updatePlaylistItems",
	    value: function updatePlaylistItems(playlistId, data) {
	      return this.getHTTP().put("/v2/playlists/" + playlistId + "/items", data);
	    }
	  }, {
	    key: "download",
	    value: function download(playlistId) {
	      if (playlistId) {
	        return this.getHTTP().get("/v2/playlists/" + playlistId + "/export?download=", {
	          responseType: "blob"
	        });
	      } else {
	        return this.getHTTP().get("/v1/export?download=", {
	          responseType: "blob"
	        });
	      }
	    }
	  }, {
	    key: "getTags",
	    value: function getTags() {
	      return this.getHTTP().get("/v2/tags");
	    }
	  }, {
	    key: "getTag",
	    value: function getTag(id) {
	      return this.getHTTP().get("v2/tags/" + id);
	    }
	  }, {
	    key: "postTag",
	    value: function postTag(tag) {
	      return this.getHTTP().post("v2/tags/", tag);
	    }
	  }, {
	    key: "getUserKnowledge",
	    value: function getUserKnowledge(userID, songID) {
	      return this.getHTTP().get("/v2/users/" + userID + "/song-versions/" + songID + "/knowledge");
	    }
	  }, {
	    key: "setUserKnowledge",
	    value: function setUserKnowledge(userID, songID, value) {
	      return this.getHTTP().put("/v2/users/" + userID + "/song-versions/" + songID + "/knowledge", value, {
	        headers: {
	          'Content-Type': 'text/plain'
	        }
	      });
	    }
	  }]);
	  return Kithara;
	}();
	
	exports.default = Kithara;

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onBottom = onBottom;
	function onBottom(callback) {
	  window.onscroll = function () {
	    var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
	
	    var scrollHeight = document.documentElement && document.documentElement.scrollHeight || document.body.scrollHeight;
	
	    var scrolledToBottom = scrollTop + window.innerHeight >= scrollHeight;
	
	    if (scrolledToBottom) {
	      callback();
	    }
	  };
	  window.onscroll();
	}

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _process = __webpack_require__(63);
	
	var _process2 = _interopRequireDefault(_process);
	
	var _auth = __webpack_require__(144);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _download = __webpack_require__(145);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _playlists = __webpack_require__(149);
	
	var _playlists2 = _interopRequireDefault(_playlists);
	
	var _playlistItems = __webpack_require__(148);
	
	var _playlistItems2 = _interopRequireDefault(_playlistItems);
	
	var _songs = __webpack_require__(150);
	
	var _songs2 = _interopRequireDefault(_songs);
	
	var _teamSongs = __webpack_require__(151);
	
	var _teamSongs2 = _interopRequireDefault(_teamSongs);
	
	var _tags = __webpack_require__(147);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _playlistTemplates = __webpack_require__(146);
	
	var _playlistTemplates2 = _interopRequireDefault(_playlistTemplates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  strict: _process2.default.env.NODE_ENV !== "production",
	  modules: {
	    authentication: _auth2.default,
	    download: _download2.default,
	    playlists: _playlists2.default,
	    playlistItems: _playlistItems2.default,
	    songs: _songs2.default,
	    teamSongs: _teamSongs2.default,
	    tags: _tags2.default,
	    playlistTemplates: _playlistTemplates2.default
	  }
	});
	
	exports.default = store;

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(230)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(122),
	  /* template */
	  __webpack_require__(317),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(229)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(123),
	  /* template */
	  __webpack_require__(316),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(233)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(124),
	  /* template */
	  __webpack_require__(320),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(223)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(127),
	  /* template */
	  __webpack_require__(310),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    iconClass: {
	      required: true,
	      type: String
	    }
	  }
	};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    destination: {
	      required: true,
	      type: String
	    }
	  }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _vuedraggable = __webpack_require__(331);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    draggable: _vuedraggable2.default
	  },
	  props: {
	    hasDelete: {
	      default: false,
	      type: Boolean
	    },
	    draggable: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      drag: _vuedraggable2.default
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlistItems: "playlistItems"
	  }), {
	    locPlaylistItems: {
	      get: function get() {
	        return this.playlistItems;
	      },
	      set: function set(value) {
	        this.updatePlaylisItemsOrder(value);
	      }
	    },
	    dragOptions: function dragOptions() {
	      return {
	        animation: 200,
	        group: "description",
	        disabled: false,
	        ghostClass: "ghost"
	      };
	    }
	  }),
	  methods: (0, _extends3.default)({
	    getCaption: function getCaption(item) {
	      if (item.caption) {
	        return item.caption + " : ";
	      } else if (item.template_item) {
	        return item.template_item.caption + " : ";
	      }
	    }
	  }, (0, _vuex.mapActions)(["updatePlaylisItemsOrder"]))
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _infiniteLoading = __webpack_require__(23);
	
	var _DraggablePlaylistItems = __webpack_require__(96);
	
	var _DraggablePlaylistItems2 = _interopRequireDefault(_DraggablePlaylistItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DraggablePlaylistItems: _DraggablePlaylistItems2.default
	  },
	  data: function data() {
	    return {
	      templateName: ""
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlist: "selectedPlaylist",
	    playlistItems: "playlistItems"
	  }), {
	    filteredTemplates: function filteredTemplates() {
	      var _this = this;
	
	      return this.list.filter(function (template) {
	        return template.name.toLowerCase().includes(_this.templateName.toLowerCase());
	      });
	    }
	  }, (0, _vuex.mapState)("playlistTemplates", ["current", "list"])),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.fetchTemplates();
	    if (this.playlist.id) {
	      this.$store.dispatch("loadMorePlaylistItems");
	      (0, _infiniteLoading.onBottom)(function () {
	        _this2.$store.dispatch("loadMorePlaylistItems");
	      });
	    }
	  },
	
	  methods: (0, _extends3.default)({
	    updateName: function updateName(value) {
	      this.update("name", value);
	    },
	    updateTemplate: function updateTemplate(value) {
	      var val = null;
	      if (value && value.id) val = value.id;
	      this.update("template_id", val);
	    },
	    update: function update(path, value) {
	      this.$emit("update", {
	        path: path,
	        value: value
	      });
	    },
	    editPlaylistItem: function editPlaylistItem(playlist, item) {
	      this.setPlaylistItem(item);
	      this.$router.push({
	        name: "edit-playlist-item",
	        params: { playlistId: playlist.id, playlistItemId: item.id }
	      });
	    },
	    handleRemovePlaylistItem: function handleRemovePlaylistItem(item) {
	      this.removePlaylistItem({
	        playlistId: this.playlist.id,
	        playlistItemId: item.id
	      });
	    }
	  }, (0, _vuex.mapActions)(["selectPlaylistItem", "removePlaylistItem"]), (0, _vuex.mapActions)("playlistTemplates", ["fetchTemplates"]), (0, _vuex.mapActions)(["setPlaylistItem"]))
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _SearchSong = __webpack_require__(297);
	
	var _SearchSong2 = _interopRequireDefault(_SearchSong);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SearchSong: _SearchSong2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlistItem: "selectedPlaylistItem",
	    songTags: "selectedPlaylistItemTags"
	  }), (0, _vuex.mapState)(["tags"])),
	  mounted: function mounted() {
	    this.fetchPlayListItem({
	      playlistId: this.$route.params.playlistId,
	      itemId: this.$route.params.playlistItemId
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    getCaption: function getCaption() {
	      if (this.playlistItem.caption == null) {
	        return this.playlistItem.template_item ? this.playlistItem.template_item.caption : "";
	      } else return this.playlistItem.caption;
	    }
	  }, (0, _vuex.mapActions)(["updatePlaylistItem", "fetchPlayListItem"]), {
	    update: function update(path, value) {
	      this.updatePlaylistItem({
	        path: path,
	        value: value
	      });
	    }
	  })
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _infiniteLoading = __webpack_require__(23);
	
	var _DraggablePlaylistItems = __webpack_require__(96);
	
	var _DraggablePlaylistItems2 = _interopRequireDefault(_DraggablePlaylistItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Array.prototype.head = function () {
	  return this.length > 0 ? this[0] : null;
	};
	
	exports.default = {
	  components: {
	    DraggablePlaylistItems: _DraggablePlaylistItems2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlist: "selectedPlaylist"
	  })),
	  mounted: function mounted() {
	    var _this = this;
	
	    (0, _infiniteLoading.onBottom)(function () {
	      _this.loadMorePlaylistItems();
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    getQueryTags: function getQueryTags(item) {
	      return item.template_item.tags.length > 1 ? item.template_item.tags.map(function (tag) {
	        return tag.name;
	      }) : item.template_item.tags.head().name;
	    },
	    showPlaylistItem: function showPlaylistItem(item) {
	      if (item.song_version) this.$router.push({
	        name: "song",
	        params: { id: item.song_version.id }
	      });
	    }
	  }, (0, _vuex.mapActions)(["loadMorePlaylistItems"]))
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    showTags: {
	      default: false,
	      type: Boolean
	    },
	    initialTags: {
	      default: function _default() {
	        return [];
	      },
	
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      availableTags: [],
	      filteredSongs: [],
	      selectedTags: [],
	      isFetchingSongs: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(["tags"])),
	  mounted: function mounted() {
	    this.fetchTags();
	    this.selectedTags = this.initialTags.slice(0);
	    this.filterSongs();
	  },
	
	  methods: (0, _extends3.default)({
	    filterSongs: function filterSongs() {
	      var _this = this;
	
	      this.changeSongsFilter({
	        main: this.nameFilter,
	        tags: this.selectedTags.map(function (tag) {
	          return tag.id;
	        })
	      });
	
	      this.loadAllSongs().then(function (resp) {
	        _this.filteredSongs = resp;
	      });
	    },
	    getFilteredTags: function getFilteredTags(name) {
	      var _this2 = this;
	
	      this.availableTags = this.tags.list.filter(function (tag) {
	        return tag.name.toLowerCase().includes(name.toLowerCase());
	      }).filter(function (tag) {
	        return !_this2.selectedTags.map(function (t) {
	          return t.name === tag.name;
	        }).includes(true);
	      });
	    },
	
	    getAsyncSongs: (0, _lodash.debounce)(function (name) {
	      var _this3 = this;
	
	      if (!(typeof name == "string")) {
	        name = "";
	      }
	      this.isFetchingSongs = true;
	
	      this.changeSongsFilter({
	        main: name,
	        tags: this.selectedTags.map(function (tag) {
	          return tag.id;
	        })
	      });
	
	      this.loadAllSongs().then(function (data) {
	        _this3.filteredSongs = [];
	        data.forEach(function (item) {
	          return _this3.filteredSongs.push(item);
	        });
	      }).catch(function (error) {
	        _this3.filteredSongs = [];
	        throw error;
	      }).finally(function () {
	        _this3.isFetchingSongs = false;
	      });
	    }, 500)
	  }, (0, _vuex.mapActions)(["fetchTags", "changeSongsFilter", "loadAllSongs"]))
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _autosize = __webpack_require__(100);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _lodash = __webpack_require__(13);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive("autosize", {
	  bind: function bind(el) {
	    _vue2.default.nextTick(function () {
	      var tagName = el.tagName;
	      if (tagName == "TEXTAREA") {
	        (0, _autosize2.default)(el);
	      }
	    });
	  },
	  componentUpdated: function componentUpdated(el) {
	    _vue2.default.nextTick(function () {
	      var tagName = el.tagName;
	      if (tagName == "TEXTAREA") {
	        _autosize2.default.update(el);
	      }
	    });
	  },
	  unbind: function unbind(el) {
	    _autosize2.default.destroy(el);
	  }
	});
	
	exports.default = {
	  props: {
	    initialSong: Object
	  },
	  data: function data() {
	    return {
	      song: (0, _lodash.cloneDeep)(this.initialSong),
	      displayedTags: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(["tags"])),
	  beforeMount: function beforeMount() {
	    this.$store.dispatch("fetchTags");
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.fetchTags().then(function (tags) {
	      _this.displayedTags = tags.filter(function (tag) {
	        return !_this.song.song.tags.map(function (t) {
	          return t.name === tag.name;
	        }).includes(true);
	      });
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    update: function update(path, value) {
	      this.$emit("update", {
	        path: path,
	        value: value
	      });
	    },
	    filterUsedTags: function filterUsedTags() {
	      var _this2 = this;
	
	      return this.tags.list.filter(function (tag) {
	        return !_this2.song.song.tags.map(function (t) {
	          return t.name === tag.name;
	        }).includes(true);
	      });
	    },
	    getFilteredTags: function getFilteredTags(name) {
	      this.displayedTags = this.filterUsedTags().filter(function (tag) {
	        return tag.name.toLowerCase().includes(name.toLowerCase());
	      });
	    }
	  }, (0, _vuex.mapActions)(["fetchTags"]))
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _PlaylistItemEdit = __webpack_require__(98);
	
	var _PlaylistItemEdit2 = _interopRequireDefault(_PlaylistItemEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlaylistItemEdit: _PlaylistItemEdit2.default
	  },
	  data: function data() {
	    return {
	      buttonActionIconClass: "fas fa-check"
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlistItem: "selectedPlaylistItem"
	  })),
	  created: function created() {
	    var playlistId = this.$route.params.playlistId;
	    this.fetchPlaylist(playlistId);
	    this.fetchPlayListItem({
	      playlistId: playlistId,
	      itemId: this.$route.params.playlistItemId
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    onUpdate: function onUpdate(event) {
	      this.$store.commit("PLAYLIST_ITEMS_UPDATE_SELECTED", event);
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.playlistItem && this.playlistItem.template_item && !this.playlistItem.caption) this.setPlayListItemCaption(this.playlistItem.template_item.caption);
	      this.savePlaylistItem().then(function () {
	        _this.$router.push({
	          name: "playlist",
	          params: { playlistId: _this.$route.params.playlistId },
	          query: { edit: "true" }
	        });
	      });
	    }
	  }, (0, _vuex.mapActions)(["savePlaylistItem", "setPlayListItemCaption", "fetchPlayListItem", "fetchPlaylist", "refreshSongs"]))
	};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      navbarShown: false
	    };
	  },
	
	  methods: {
	    toggleNavbar: function toggleNavbar() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.navbarShown = value === null ? !this.navbarShown : value;
	    },
	    download: function download() {
	      var _this = this;
	
	      this.$store.dispatch("download").then(function () {
	        return _this.toggleNavbar(false);
	      });
	    },
	    logout: function logout() {
	      var _this2 = this;
	
	      this.$store.dispatch("logout").then(function () {
	        return _this2.$router.push("/login");
	      });
	    }
	  }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        username: "",
	        password: ""
	      },
	      error: undefined
	    };
	  },
	
	  methods: {
	    login: function login() {
	      var _this = this;
	
	      this.$store.dispatch("login", this.credentials).then(function () {
	        return _this.$router.push(_this.$route.query.redirect || "/");
	      }).catch(function (e) {
	        return _this.error = e.response.data.message;
	      });
	    },
	    logout: function logout() {
	      this.$store.dispatch("logout");
	    }
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _PlaylistEdit = __webpack_require__(97);
	
	var _PlaylistEdit2 = _interopRequireDefault(_PlaylistEdit);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlaylistEdit: _PlaylistEdit2.default
	  },
	  data: function data() {
	    return {
	      buttonActionIconClass: "fas fa-check"
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("playlistTemplates", ["current"])),
	  mounted: function mounted() {
	    this.clearCurrentPlaylist();
	  },
	
	  methods: (0, _extends3.default)({
	    save: function save() {
	      var _this = this;
	
	      this.createPlaylist().then(function (response) {
	        var id = response.data.id;
	        _this.$router.push({
	          name: "playlist",
	          params: { playlistId: id },
	          query: { edit: "true" }
	        });
	      });
	    }
	  }, (0, _vuex.mapActions)(["updatePlaylistElement", "createPlaylist", "clearCurrentPlaylist"]))
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _PlaylistItemEdit = __webpack_require__(98);
	
	var _PlaylistItemEdit2 = _interopRequireDefault(_PlaylistItemEdit);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlaylistItemEdit: _PlaylistItemEdit2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({ playlist: "selectedPlaylist" })),
	  mounted: function mounted() {
	    this.fetchPlaylist(this.$route.params.playlistId);
	  },
	
	  methods: (0, _extends3.default)({
	    save: function save() {
	      var _this = this;
	
	      this.$store.dispatch("createPlaylistItem").then(function () {
	        _this.$router.push({
	          name: "playlist",
	          params: { playlistId: _this.$route.params.playlistId },
	          query: { edit: "true" }
	        });
	      });
	    }
	  }, (0, _vuex.mapActions)(["fetchPlaylist"]))
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SongEdit = __webpack_require__(99);
	
	var _SongEdit2 = _interopRequireDefault(_SongEdit);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SongEdit: _SongEdit2.default
	  },
	  data: function data() {
	    return {
	      song: {
	        song: {
	          composer: {},
	          tags: []
	        },
	        title: "",
	        lyrics: "",
	        translator: {}
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.clearSong();
	  },
	
	  methods: (0, _extends3.default)({
	    save: function save() {
	      var _this = this;
	
	      this.createSong().then(function () {
	        _this.$router.push("/");
	      });
	    }
	  }, (0, _vuex.mapActions)(["updateSelectedSong", "createSong", "clearSong"]))
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _PlaylistEdit = __webpack_require__(97);
	
	var _PlaylistEdit2 = _interopRequireDefault(_PlaylistEdit);
	
	var _PlaylistShow = __webpack_require__(296);
	
	var _PlaylistShow2 = _interopRequireDefault(_PlaylistShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlaylistEdit: _PlaylistEdit2.default,
	    PlaylistShow: _PlaylistShow2.default
	  },
	  data: function data() {
	    return {
	      editMode: this.$route.query.edit
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlist: "selectedPlaylist",
	    playlistItems: "playlistItems"
	  })),
	  created: function created() {
	    var playlistId = this.$route.params.playlistId;
	    this.refreshPlaylistItems();
	    this.fetchPlaylist(playlistId);
	    this.fetchPlaylistItems(playlistId);
	  },
	
	  methods: (0, _extends3.default)({
	    deleteThisPlaylist: function deleteThisPlaylist() {
	      var _this = this;
	
	      if (confirm("Do you really want to delete?")) {
	        this.deletePlaylist({ id: this.$route.params.playlistId }).then(function () {
	          _this.$router.push("/playlists");
	        });
	      }
	    },
	    setupQuery: function setupQuery() {
	      var query = {};
	      if (this.editMode) query.edit = this.editMode;
	      this.$router.replace({ query: query });
	    },
	    toggleEdit: function toggleEdit() {
	      if (this.editMode) this.savePlaylist();
	      this.editMode = !this.editMode;
	      this.setupQuery();
	    }
	  }, (0, _vuex.mapActions)(["fetchPlaylistItems", "fetchPlaylist", "deletePlaylist", "savePlaylist", "updatePlaylistElement", "refreshPlaylistItems"]))
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _infiniteLoading = __webpack_require__(23);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      addLink: "new-playlist"
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    playlists: "playlists"
	  }), {
	    filter: {
	      get: function get() {
	        return this.$store.getters.playlistsFilter;
	      },
	      set: function set(value) {
	        this.changeFilter(value).then(this.refreshPlaylists.bind(this));
	      }
	    }
	  }),
	  created: function created() {
	    this.$store.dispatch("changePlaylistsFilter").then(this.setupQuery(this.filter));
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.quickRefreshPlaylists();
	    (0, _infiniteLoading.onBottom)(function () {
	      _this.$store.dispatch("loadMorePlaylists");
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    setupQuery: function setupQuery(filter) {
	      var query = {};
	      if (filter) {
	        query.filter = filter;
	      }
	      this.$router.replace({ query: query });
	    },
	    showPlaylist: function showPlaylist(playlist) {
	      this.setCurrentPlayList(playlist);
	      this.$router.push({
	        name: "playlist",
	        params: { playlistId: playlist.id }
	      });
	    },
	    changeFilter: function changeFilter(value) {
	      this.setupQuery(value);
	      return this.$store.dispatch("changePlaylistsFilter", value);
	    },
	    clearFilter: function clearFilter() {
	      return this.changeFilter("").then(this.quickRefreshPlaylists.bind(this));
	    },
	    quickRefreshPlaylists: function quickRefreshPlaylists() {
	      this.$store.dispatch("refreshPlaylists").then(this.$store.dispatch("loadMorePlaylists"));
	    },
	
	    refreshPlaylists: (0, _lodash.debounce)(function () {
	      this.quickRefreshPlaylists();
	    }, 500)
	  }, (0, _vuex.mapActions)(["setCurrentPlayList"]))
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(165);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(161);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SongEdit = __webpack_require__(99);
	
	var _SongEdit2 = _interopRequireDefault(_SongEdit);
	
	var _song_parser = __webpack_require__(143);
	
	var _song_parser2 = _interopRequireDefault(_song_parser);
	
	var _song_formatter = __webpack_require__(142);
	
	var _song_formatter2 = _interopRequireDefault(_song_formatter);
	
	var _vuex = __webpack_require__(3);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	exports.default = {
	  components: {
	    SongEdit: _SongEdit2.default
	  },
	  data: function data() {
	    return {
	      editMode: this.$route.query.edit,
	      format: "chords",
	      formatter: new _song_formatter2.default(),
	      knowledge: 0,
	      quality: 0,
	      isWakeLocked: false,
	      wakeLock: null
	    };
	  },
	
	  computed: {
	    song: {
	      get: function get() {
	        return this.$store.getters.selectedSong;
	      }
	    },
	    userData: {
	      get: function get() {
	        return this.$store.getters.userData;
	      }
	    },
	    songHTML: {
	      get: function get() {
	        if (this.song && this.song.lyrics) {
	          var parser = new _song_parser2.default();
	          var song = parser.parse(this.song.lyrics);
	          return this.formatter.format(song);
	        } else {
	          return "";
	        }
	      }
	    },
	    knowledgeClassObject: {
	      get: function get() {
	        return {
	          "knowledge-none": !this.knowledge || this.knowledge === 0,
	          "knowledge-bad is-danger": this.knowledge === 1,
	          "knowledge-medium is-warning": this.knowledge === 2,
	          "knowledge-good is-success": this.knowledge >= 3
	        };
	      }
	    },
	    qualityClassObject: {
	      get: function get() {
	        var quality = this.song.properties ? this.song.properties.quality : 0;
	        return {
	          fas: true,
	          "quality-unknown fa-eye-slash": !quality || quality === 0,
	          "quality-need-review fa-eye": quality === 1,
	          "quality-certified fa-award": quality === 2
	        };
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$store.dispatch("selectSong").then(function () {
	      _this.quality = _this.song.properties.quality || 0;
	      return kithara.getUserKnowledge(_this.userData.id, _this.song.id) || 0;
	    }).then(function (response) {
	      _this.knowledge = response.data || 0;
	    });
	
	    document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.releaseWakeLock();
	    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
	  },
	
	  methods: (0, _extends3.default)({
	    handleVisibilityChange: function handleVisibilityChange() {
	      if (!this.isWakeLocked) return;
	      if (document.hidden) {
	        this.releaseWakeLock();
	        return;
	      }
	      this.acquireWakeLock();
	    },
	    remove: function remove() {
	      var _this2 = this;
	
	      if (confirm("Do you really want to delete?")) {
	        this.deleteSong().then(function () {
	          _this2.$router.push("/");
	        });
	      }
	    },
	    setupQuery: function setupQuery() {
	      var query = {};
	      if (this.editMode) query.edit = this.editMode;
	      this.$router.replace({ query: query });
	    },
	    toggleEdit: function toggleEdit() {
	      if (this.editMode) this.saveSong();
	      this.editMode = !this.editMode;
	      this.setupQuery();
	    },
	    setFormatter: function setFormatter(value) {
	      this.format = value;
	    },
	    changeKnowledge: function changeKnowledge() {
	      this.knowledge = (this.knowledge + 1) % 4;
	      return kithara.setUserKnowledge(this.userData.id, this.song.id, this.knowledge);
	    },
	    changeQuality: function changeQuality() {
	      var _this3 = this;
	
	      this.quality = (this.quality + 1) % 3;
	      this.updateSelectedSong({
	        path: "properties.quality",
	        value: this.quality
	      }).then(function () {
	        _this3.saveSong();
	      });
	    },
	    acquireWakeLock: function acquireWakeLock() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var requestWakeLock;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(_this4.wakeLock === null)) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                requestWakeLock = function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return navigator.wakeLock.request("screen");
	
	                          case 3:
	                            _this4.wakeLock = _context.sent;
	
	                            _this4.wakeLock.addEventListener("release", function () {});
	                            _context.next = 9;
	                            break;
	
	                          case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                          case 9:
	                          case "end":
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this4, [[0, 7]]);
	                  }));
	
	                  return function requestWakeLock() {
	                    return _ref.apply(this, arguments);
	                  };
	                }();
	
	                _context2.next = 4;
	                return requestWakeLock();
	
	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4);
	      }))();
	    },
	    releaseWakeLock: function releaseWakeLock() {
	      if (this.wakeLock !== null) {
	        this.wakeLock.release();
	        this.wakeLock = null;
	      }
	    },
	    wakeLockAvailable: function wakeLockAvailable() {
	      return "wakeLock" in navigator;
	    },
	    toggleWakeLock: function toggleWakeLock() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!_this5.isWakeLocked) {
	                  _context3.next = 5;
	                  break;
	                }
	
	                _this5.releaseWakeLock();
	                _this5.isWakeLocked = false;
	                _context3.next = 8;
	                break;
	
	              case 5:
	                _context3.next = 7;
	                return _this5.acquireWakeLock();
	
	              case 7:
	                _this5.isWakeLocked = true;
	
	              case 8:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this5);
	      }))();
	    }
	  }, (0, _vuex.mapActions)(["updateSelectedSong", "saveSong", "deleteSong"]))
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _lodash = __webpack_require__(13);
	
	var _infiniteLoading = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      addLink: "new-song"
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    songs: "songs"
	  }), {
	    filter: {
	      get: function get() {
	        return this.$store.getters.songsFilter;
	      },
	      set: function set(value) {
	        this.changeFilter(value).then(this.debouncedRefreshSongs.bind(this));
	      }
	    }
	  }),
	  mounted: function mounted() {
	    var _this = this;
	
	    (0, _infiniteLoading.onBottom)(function () {
	      _this.loadMoreSongs();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.onscroll = function () {};
	  },
	
	  methods: (0, _extends3.default)({
	    setupQuery: function setupQuery(filter) {
	      var query = {};
	      if (filter) {
	        query.filter = filter;
	      }
	      this.$router.replace({ query: query });
	    },
	    showSong: function showSong(song) {
	      this.$router.push({ name: "song", params: { id: song.id } });
	    },
	    changeFilter: function changeFilter(value) {
	      this.setupQuery(value);
	      return this.changeSongsFilter({ main: value, tags: [] });
	    },
	    clearFilter: function clearFilter() {
	      return this.changeFilter("").then(this.quickRefreshSongs.bind(this));
	    },
	    quickRefreshSongs: function quickRefreshSongs() {
	      return this.refreshSongs().then(this.loadMoreSongs());
	    },
	
	    debouncedRefreshSongs: (0, _lodash.debounce)(function () {
	      return this.quickRefreshSongs();
	    }, 500)
	  }, (0, _vuex.mapActions)(["changeSongsFilter", "refreshSongs", "loadMoreSongs"]))
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _lodash = __webpack_require__(13);
	
	var _infiniteLoading = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      addLink: "new-song"
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    teamSongs: "teamSongs"
	  }), {
	    filter: {
	      get: function get() {
	        return this.$store.getters.teamSongsFilter;
	      },
	      set: function set(value) {
	        this.changeFilter(value).then(this.debouncedRefreshTeamSongs.bind(this));
	      }
	    }
	  }),
	  mounted: function mounted() {
	    var _this = this;
	
	    (0, _infiniteLoading.onBottom)(function () {
	      _this.loadMoreTeamSongs();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.onscroll = function () {};
	  },
	
	  methods: (0, _extends3.default)({
	    setupQuery: function setupQuery(filter) {
	      var query = {};
	      if (filter) {
	        query.filter = filter;
	      }
	      this.$router.replace({ query: query });
	    },
	    showTeamSong: function showTeamSong(teamSong) {
	      this.$router.push({ name: "song", params: { id: teamSong.id } });
	    },
	    changeFilter: function changeFilter(value) {
	      this.setupQuery(value);
	      return this.changeTeamSongsFilter({ main: value, tags: [] });
	    },
	    clearFilter: function clearFilter() {
	      return this.changeFilter("").then(this.quickRefreshTeamSongs.bind(this));
	    },
	    quickRefreshTeamSongs: function quickRefreshTeamSongs() {
	      return this.refreshTeamSongs().then(this.loadMoreTeamSongs());
	    },
	
	    debouncedRefreshTeamSongs: (0, _lodash.debounce)(function () {
	      return this.quickRefreshTeamSongs();
	    }, 500)
	  }, (0, _vuex.mapActions)(["changeTeamSongsFilter", "refreshTeamSongs", "loadMoreTeamSongs"]))
	};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(71);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	function JWT() {}
	
	JWT.login = function (username, password) {
	  return kithara.login(username, password).then(function (response) {
	    return localStorage.setItem("kithara.token", response.data.token);
	  });
	};
	
	JWT.logout = function () {
	  var token = localStorage.removeItem("kithara.token");
	  return _promise2.default.resolve(token);
	};
	
	JWT.isLoggedIn = function () {
	  if (this.getToken() === null) {
	    return false;
	  }
	  var now = new Date();
	  var expiration = new Date(this.getData().exp * 1000);
	  return now.getTime() < expiration.getTime();
	};
	
	JWT.getToken = function () {
	  return localStorage.getItem("kithara.token");
	};
	
	JWT.getData = function () {
	  var base64Url = this.getToken().split(".")[1];
	  var base64 = base64Url.replace("-", "+").replace("_", "/");
	  return JSON.parse(Buffer.from(base64, "base64").toString("binary"));
	};
	
	exports.default = JWT;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(286).Buffer))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(157);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _from = __webpack_require__(152);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(329);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _store = __webpack_require__(69);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(293);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Login = __webpack_require__(300);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Home = __webpack_require__(299);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Playlist = __webpack_require__(304);
	
	var _Playlist2 = _interopRequireDefault(_Playlist);
	
	var _Playlists = __webpack_require__(305);
	
	var _Playlists2 = _interopRequireDefault(_Playlists);
	
	var _NewPlaylist = __webpack_require__(301);
	
	var _NewPlaylist2 = _interopRequireDefault(_NewPlaylist);
	
	var _EditPlaylistItem = __webpack_require__(298);
	
	var _EditPlaylistItem2 = _interopRequireDefault(_EditPlaylistItem);
	
	var _NewPlaylistItem = __webpack_require__(302);
	
	var _NewPlaylistItem2 = _interopRequireDefault(_NewPlaylistItem);
	
	var _Songs = __webpack_require__(307);
	
	var _Songs2 = _interopRequireDefault(_Songs);
	
	var _SongsTable = __webpack_require__(308);
	
	var _SongsTable2 = _interopRequireDefault(_SongsTable);
	
	var _Song = __webpack_require__(306);
	
	var _Song2 = _interopRequireDefault(_Song);
	
	var _NewSong = __webpack_require__(303);
	
	var _NewSong2 = _interopRequireDefault(_NewSong);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: "history",
	  routes: [{
	    path: "",
	    name: "root",
	    redirect: "/",
	    component: _App2.default,
	    meta: {
	      title: "Kithara"
	    },
	    children: [{
	      path: "login",
	      name: "login",
	      component: _Login2.default
	    }, {
	      path: "",
	      name: "home",
	      redirect: "/",
	      component: _Home2.default,
	      beforeEnter: guardRoute,
	      children: [{
	        path: "",
	        name: "songs",
	        component: _Songs2.default
	      }, {
	        path: "/table",
	        name: "table",
	        component: _SongsTable2.default
	      }, {
	        path: "/songs/:id",
	        name: "song",
	        component: _Song2.default
	      }, {
	        path: "/new-song",
	        name: "new-song",
	        component: _NewSong2.default
	      }, {
	        path: "/playlists",
	        name: "playlists",
	        component: _Playlists2.default
	      }, {
	        path: "/playlists/:playlistId",
	        name: "playlist",
	        component: _Playlist2.default
	      }, {
	        path: "/new-playlist",
	        name: "new-playlist",
	        component: _NewPlaylist2.default
	      }, {
	        path: "/playlists/:playlistId/edit-item/:playlistItemId",
	        name: "edit-playlist-item",
	        component: _EditPlaylistItem2.default
	      }, {
	        path: "/playlists/:playlistId/new-item",
	        name: "new-playlist-item",
	        component: _NewPlaylistItem2.default
	      }],
	      meta: {
	        htmlClass: "has-navbar-fixed-top"
	      }
	    }]
	  }],
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition;
	    } else {
	      return { x: 0, y: 0 };
	    }
	  }
	});
	
	function guardRoute(to, from, next) {
	
	  if (!_store2.default.getters.isLoggedIn) {
	    next({
	      path: "/login",
	      query: { redirect: to.fullPath }
	    });
	  } else {
	    next();
	  }
	}
	
	router.beforeEach(function (to, from, next) {
	  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
	    return r.meta && r.meta.title;
	  });
	
	  var nearestWithHTMLClass = to.matched.slice().reverse().find(function (r) {
	    return r.meta && r.meta.htmlClass;
	  });
	  if (nearestWithHTMLClass) {
	    document.querySelector("html").setAttribute("class", nearestWithHTMLClass.meta.htmlClass);
	  } else {
	    document.querySelector("html").setAttribute("class", "");
	  }
	
	  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
	    return r.meta && r.meta.metaTags;
	  });
	
	  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
	
	  (0, _from2.default)(document.querySelectorAll("[data-vue-router-controlled]")).map(function (el) {
	    return el.parentNode.removeChild(el);
	  });
	
	  if (!nearestWithMeta) return next();
	
	  nearestWithMeta.meta.metaTags.map(function (tagDef) {
	    var tag = document.createElement("meta");
	
	    (0, _keys2.default)(tagDef).forEach(function (key) {
	      tag.setAttribute(key, tagDef[key]);
	    });
	
	    tag.setAttribute("data-vue-router-controlled", "");
	
	    return tag;
	  }).forEach(function (tag) {
	    return document.head.appendChild(tag);
	  });
	
	  next();
	});
	
	exports.default = router;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	exports.default = {
	  getTemplates: function getTemplates() {
	    return kithara.getHTTP().get("/v2/templates");
	  },
	  getTemplate: function getTemplate(id) {
	    return kithara.getHTTP().get("/v2/templates/" + id);
	  },
	  postTemplate: function postTemplate(template) {
	    return kithara.getHTTP().post("/v2/templates", template);
	  },
	  putTemplate: function putTemplate(id, template) {
	    return kithara.getHTTP().put("/v2/templates/" + id, template);
	  },
	  deleteTemplate: function deleteTemplate(id) {
	    return kithara.getHTTP().delete("/v2/templates/" + id);
	  }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _typeof2 = __webpack_require__(42);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _runtime = __webpack_require__(37);
	
	var _runtime2 = _interopRequireDefault(_runtime);
	
	var _chordsheetjs = __webpack_require__(73);
	
	var _chordsheetjs2 = _interopRequireDefault(_chordsheetjs);
	
	__webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = _runtime2.default.template({
	  "1": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return ((stack1 = helpers["if"].call(alias1, depth0 != null ? depth0.title : depth0, {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(2, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + ((stack1 = helpers["if"].call(alias1, depth0 != null ? depth0.subtitle : depth0, {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(4, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + "<div class=\"chord-sheet\">" + ((stack1 = helpers.each.call(alias1, depth0 != null ? depth0.paragraphs : depth0, {
	      "name": "each",
	      "hash": {},
	      "fn": container.program(6, data, 1, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + "</div>";
	  },
	  "2": function _(container, depth0, helpers, partials, data) {
	    var helper;
	    return "<h1>" + container.escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
	      "name": "title",
	      "hash": {},
	      "data": data
	    }) : helper)) + "</h1>";
	  },
	  "4": function _(container, depth0, helpers, partials, data) {
	    var helper;
	    return "<h2>" + container.escapeExpression((helper = (helper = helpers.subtitle || (depth0 != null ? depth0.subtitle : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
	      "name": "subtitle",
	      "hash": {},
	      "data": data
	    }) : helper)) + "</h2>";
	  },
	  "6": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return "<div class=\"" + container.escapeExpression((helpers.paragraphClasses || depth0 && depth0.paragraphClasses || helpers.helperMissing).call(alias1, blockParams[0][0], {
	      "name": "paragraphClasses",
	      "hash": {},
	      "data": data,
	      "blockParams": blockParams
	    })) + "\">" + ((stack1 = helpers.each.call(alias1, depth0 != null ? depth0.lines : depth0, {
	      "name": "each",
	      "hash": {},
	      "fn": container.program(7, data, 1, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + "</div>";
	  },
	  "7": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return (stack1 = helpers["if"].call(alias1, (helpers.shouldRenderLine || depth0 && depth0.shouldRenderLine || helpers.helperMissing).call(alias1, blockParams[0][0], {
	      "name": "shouldRenderLine",
	      "hash": {},
	      "data": data,
	      "blockParams": blockParams
	    }), {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(8, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "";
	  },
	  "8": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return "<div class=\"" + container.escapeExpression((helpers.lineClasses || depth0 && depth0.lineClasses || helpers.helperMissing).call(alias1, blockParams[1][0], {
	      "name": "lineClasses",
	      "hash": {},
	      "data": data,
	      "blockParams": blockParams
	    })) + "\">" + ((stack1 = helpers.each.call(alias1, depth0 != null ? depth0.words : depth0, {
	      "name": "each",
	      "hash": {},
	      "fn": container.program(9, data, 1, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + "</div>";
	  },
	  "9": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return "<div class=\"word\">" + ((stack1 = helpers.each.call(alias1, depth0 != null ? depth0.items : depth0, {
	      "name": "each",
	      "hash": {},
	      "fn": container.program(10, data, 1, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "") + "</div>" + ((stack1 = helpers["if"].call(alias1, (helpers.isTag || depth0 && depth0.isTag || helpers.helperMissing).call(alias1, depth0 != null ? depth0.item : depth0, {
	      "name": "isTag",
	      "hash": {},
	      "data": data,
	      "blockParams": blockParams
	    }), {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(13, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "");
	  },
	  "10": function _(container, depth0, helpers, partials, data, blockParams) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return (stack1 = helpers["if"].call(alias1, (helpers.isChordLyricsPair || depth0 && depth0.isChordLyricsPair || helpers.helperMissing).call(alias1, blockParams[0][0], {
	      "name": "isChordLyricsPair",
	      "hash": {},
	      "data": data,
	      "blockParams": blockParams
	    }), {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(11, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "";
	  },
	  "11": function _(container, depth0, helpers, partials, data) {
	    var helper,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {},
	        alias2 = helpers.helperMissing,
	        alias3 = "function",
	        alias4 = container.escapeExpression;
	    return "<div class=\"column\"><!--\n                          --><div class=\"chord\">" + alias4((helper = (helper = helpers.chords || (depth0 != null ? depth0.chords : depth0)) != null ? helper : alias2, (typeof helper === "undefined" ? "undefined" : (0, _typeof3.default)(helper)) === alias3 ? helper.call(alias1, {
	      "name": "chords",
	      "hash": {},
	      "data": data
	    }) : helper)) + "</div><!--\n                          --><div class=\"lyrics\">" + alias4((helper = (helper = helpers.lyrics || (depth0 != null ? depth0.lyrics : depth0)) != null ? helper : alias2, (typeof helper === "undefined" ? "undefined" : (0, _typeof3.default)(helper)) === alias3 ? helper.call(alias1, {
	      "name": "lyrics",
	      "hash": {},
	      "data": data
	    }) : helper)) + "</div><!--\n                        --></div>";
	  },
	  "13": function _(container, depth0, helpers, partials, data) {
	    var stack1,
	        alias1 = depth0 != null ? depth0 : container.nullContext || {};
	    return (stack1 = helpers["if"].call(alias1, (helpers.isComment || depth0 && depth0.isComment || helpers.helperMissing).call(alias1, depth0 != null ? depth0.item : depth0, {
	      "name": "isComment",
	      "hash": {},
	      "data": data
	    }), {
	      "name": "if",
	      "hash": {},
	      "fn": container.program(14, data, 0),
	      "inverse": container.noop,
	      "data": data
	    })) != null ? stack1 : "";
	  },
	  "14": function _(container, depth0, helpers, partials, data) {
	    var helper;
	    return "<div class=\"comment\">" + container.escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
	      "name": "value",
	      "hash": {},
	      "data": data
	    }) : helper)) + "</div>";
	  },
	  "compiler": [7, ">= 4.0.0"],
	  "main": function main(container, depth0, helpers, partials, data, blockParams) {
	    var stack1;
	    return (stack1 = helpers["with"].call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? depth0.song : depth0, {
	      "name": "with",
	      "hash": {},
	      "fn": container.program(1, data, 0, blockParams),
	      "inverse": container.noop,
	      "data": data,
	      "blockParams": blockParams
	    })) != null ? stack1 : "";
	  },
	  "useData": true,
	  "useBlockParams": true
	});
	
	var HtmlDivFormatter = function () {
	  function HtmlDivFormatter() {
	    (0, _classCallCheck3.default)(this, HtmlDivFormatter);
	  }
	
	  (0, _createClass3.default)(HtmlDivFormatter, [{
	    key: "format",
	    value: function format(song) {
	      song.paragraphs.forEach(function (paragraph) {
	        paragraph.lines.forEach(function (line) {
	          var words = [{ items: [] }];
	          line.items.forEach(function (item) {
	            var chord = [item.chords];
	            var tokens = item.lyrics.split(" ");
	            var trueTokens = tokens.map(function (e) {
	              return e + " ";
	            });
	            if (trueTokens.length && trueTokens[trueTokens.length - 1] === " ") {
	              delete trueTokens[trueTokens.length - 1];
	            } else {
	              var value = trueTokens[trueTokens.length - 1];
	              trueTokens[trueTokens.length - 1] = value.slice(0, value.length - 1);
	            }
	
	            trueTokens.forEach(function (lyrics) {
	              words[words.length - 1].items.push(new _chordsheetjs2.default.ChordLyricsPair(chord.pop(), lyrics));
	              if (lyrics[lyrics.length - 1] === " ") {
	                words.push({ items: [] });
	              }
	            });
	          });
	          line.words = words;
	        });
	      });
	
	      return template({ song: song });
	    }
	  }]);
	  return HtmlDivFormatter;
	}();
	
	exports.default = HtmlDivFormatter;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(70);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(164);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(162);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(163);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _chordsheetjs = __webpack_require__(73);
	
	var _chordsheetjs2 = _interopRequireDefault(_chordsheetjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChordProParser = function (_ChordSheetJS$ChordPr) {
	  (0, _inherits3.default)(ChordProParser, _ChordSheetJS$ChordPr);
	
	  function ChordProParser() {
	    (0, _classCallCheck3.default)(this, ChordProParser);
	    return (0, _possibleConstructorReturn3.default)(this, (ChordProParser.__proto__ || (0, _getPrototypeOf2.default)(ChordProParser)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ChordProParser, [{
	    key: 'applyTag',
	    value: function applyTag(tag) {
	      (0, _get3.default)(ChordProParser.prototype.__proto__ || (0, _getPrototypeOf2.default)(ChordProParser.prototype), 'applyTag', this).call(this, tag);
	
	      switch (tag.name) {
	        case 'start_of_bridge':
	          this.startSection('bridge', tag);
	          break;
	
	        case 'end_of_bridge':
	          this.endSection('bridge', tag);
	          break;
	
	        default:
	          break;
	      }
	    }
	  }]);
	  return ChordProParser;
	}(_chordsheetjs2.default.ChordProParser);
	
	exports.default = ChordProParser;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jwt = __webpack_require__(139);
	
	var _jwt2 = _interopRequireDefault(_jwt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: {
	    isLoggedIn: _jwt2.default.isLoggedIn(),
	    pending: false
	  },
	  mutations: {
	    AUTH_LOGIN: function AUTH_LOGIN(state) {
	      state.pending = true;
	    },
	    AUTH_LOGIN_SUCCESS: function AUTH_LOGIN_SUCCESS(state) {
	      state.isLoggedIn = true;
	      state.pending = false;
	    },
	    AUTH_LOGOUT: function AUTH_LOGOUT(state) {
	      state.isLoggedIn = false;
	    }
	  },
	  actions: {
	    login: function login(_ref, creds) {
	      var commit = _ref.commit;
	
	      commit("AUTH_LOGIN");
	      return _jwt2.default.login(creds.username, creds.password).then(function () {
	        return commit("AUTH_LOGIN_SUCCESS");
	      });
	    },
	    logout: function logout(_ref2) {
	      var commit = _ref2.commit;
	
	      return _jwt2.default.logout().then(function () {
	        return commit("AUTH_LOGOUT");
	      });
	    }
	  },
	  getters: {
	    isLoggedIn: function isLoggedIn(state) {
	      return state.isLoggedIn;
	    },
	    userData: function userData(state) {
	      return _jwt2.default.getData();
	    }
	  }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	exports.default = {
	  actions: {
	    download: function download(_ref) {
	      var rootState = _ref.rootState;
	
	      return kithara.download(rootState.route.params.playlistId).then(function (response) {
	        var url = window.URL.createObjectURL(new Blob([response.data]));
	        var link = document.createElement("a");
	        link.href = url;
	        link.setAttribute("download", "kithara.html");
	        document.body.appendChild(link);
	        link.click();
	      });
	    }
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlaylistTemplateService = __webpack_require__(141);
	
	var _PlaylistTemplateService2 = _interopRequireDefault(_PlaylistTemplateService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  list: [],
	  current: {}
	};
	
	exports.default = {
	  namespaced: true,
	  state: initialState,
	  mutations: {
	    ADD_TEMPLATE: function ADD_TEMPLATE(state, template) {
	      state.list.push(template);
	    },
	    SET_TEMPLATES: function SET_TEMPLATES(state, templates) {
	      state.list = templates;
	    },
	    SET_TEMPLATE: function SET_TEMPLATE(state, template) {
	      state.current = template;
	    }
	  },
	  actions: {
	    createTemplate: function createTemplate(_ref, template) {
	      var commit = _ref.commit;
	
	      return _PlaylistTemplateService2.default.postTemplate(template).then(function () {
	        commit("ADD_TEMPLATE", template);
	      });
	    },
	    fetchTemplates: function fetchTemplates(_ref2) {
	      var commit = _ref2.commit;
	
	      return _PlaylistTemplateService2.default.getTemplates().then(function (response) {
	        commit("SET_TEMPLATES", response.data.data);
	      });
	    },
	    fetchTemplate: function fetchTemplate(_ref3, id) {
	      var commit = _ref3.commit,
	          getters = _ref3.getters;
	
	      var template = getters.getElementById(id);
	      if (template) {
	        commit("SET_TEMPLATE", template);
	        return template;
	      } else {
	        return _PlaylistTemplateService2.default.getTemplate(id).then(function (response) {
	          commit("SET_TEMPLATE", response.data);
	          return response.data;
	        });
	      }
	    },
	    clearCurrent: function clearCurrent(_ref4) {
	      var commit = _ref4.commit;
	
	      commit("SET_TEMPLATE", {});
	    }
	  },
	  getters: {
	    getElementById: function getElementById(state) {
	      return function (id) {
	        return state.list.find(function (element) {
	          return element.id === id;
	        });
	      };
	    },
	    filterList: function filterList(state) {
	      return function (pattern) {
	        return state.list.filter(function (elem) {
	          return elem.name.toLowerCase().includes(pattern.toLowerCase());
	        });
	      };
	    }
	  }
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.namespaced = undefined;
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	var namespaced = exports.namespaced = true;
	
	exports.default = {
	  state: {
	    list: [],
	    current: {}
	  },
	  mutations: {
	    SET_TAGS: function SET_TAGS(state, tags) {
	      state.list = tags;
	    },
	    ADD_TAG: function ADD_TAG(state, tag) {
	      state.list.push(tag);
	    },
	    SET_TAG: function SET_TAG(state, tag) {
	      state.current = tag;
	    }
	  },
	  actions: {
	    createTag: function createTag(commit, tag) {
	      return kithara.postTag(tag).then(function (response) {
	        commit("ADD_TAG", response.data.data);
	      });
	    },
	    fetchTags: function fetchTags(_ref) {
	      var commit = _ref.commit;
	
	      return kithara.getTags().then(function (response) {
	        commit("SET_TAGS", response.data.data);
	        return response.data.data;
	      });
	    },
	    fetchTag: function fetchTag(commit, id) {
	      return kithara.getTag(id).then(function (response) {
	        commit("SET_TAG", response.data.data);
	        return response.data.data;
	      });
	    }
	  },
	  getters: {
	    filterByName: function filterByName(state) {
	      return function (name) {
	        return state.list.filter(function (tag) {
	          return tag.name.toLowerCase().includes(name.toLowerCase());
	        });
	      };
	    }
	  }
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	var defaultPlaylistItem = {
	  caption: "",
	  song_version: null
	};
	exports.default = {
	  state: {
	    list: {
	      loading: false,
	      complete: false,
	      errors: [],
	      playlistItems: [],
	      nextPage: 1,
	      pageSize: 1000,
	      filter: ""
	    },
	    editing: {
	      pending: true,
	      errors: [],
	      playlistItem: (0, _lodash.cloneDeep)(defaultPlaylistItem)
	    }
	  },
	  mutations: {
	    PLAYLIST_ITEMS_LIST_CLEAN: function PLAYLIST_ITEMS_LIST_CLEAN(state) {
	      state.list.playlistItems = [];
	      state.list.nextPage = 1;
	      state.list.complete = false;
	    },
	    PLAYLIST_ITEMS_LIST: function PLAYLIST_ITEMS_LIST(state) {
	      state.list.loading = true;
	    },
	    PLAYLIST_ITEMS_LIST_SUCCESS: function PLAYLIST_ITEMS_LIST_SUCCESS(state, payload) {
	      state.list.loading = false;
	      state.list.playlistItems = payload.playlistItems;
	      state.list.complete = payload.complete;
	      state.list.nextPage++;
	    },
	    PLAYLIST_ITEMS_LIST_FAILED: function PLAYLIST_ITEMS_LIST_FAILED(state, payload) {
	      state.list.loading = false;
	      state.list.errors = payload;
	    },
	    PLAYLIST_ITEMS_SELECT: function PLAYLIST_ITEMS_SELECT(state) {
	      state.editing.pending = false;
	      state.editing.playlistItem = (0, _lodash.cloneDeep)(defaultPlaylistItem);
	    },
	    PLAYLIST_ITEMS_SET_SELECTED: function PLAYLIST_ITEMS_SET_SELECTED(state, payload) {
	      state.editing.pending = false;
	      state.editing.playlistItem = payload;
	    },
	    PLAYLIST_ITEMS_UPDATE_SELECTED: function PLAYLIST_ITEMS_UPDATE_SELECTED(state, _ref) {
	      var path = _ref.path,
	          value = _ref.value;
	
	      state.editing.pending = false;
	      (0, _lodash.set)(state.editing.playlistItem, path, value);
	    },
	    PLAYLIST_ITEMS_UPDATE_SELECTED_IN_LIST: function PLAYLIST_ITEMS_UPDATE_SELECTED_IN_LIST(state) {
	      for (var i = 0; i < state.list.playlistItems.length; i++) {
	        if (state.list.playlistItems[i].id === parseInt(state.editing.playlistItem.id)) {
	          state.list.playlistItems[i] = state.editing.playlistItem;
	        }
	      }
	    },
	    PLAYLIST_ITEMS_ADD_SELECTED_TO_LIST: function PLAYLIST_ITEMS_ADD_SELECTED_TO_LIST(state) {
	      state.list.playlistItems.push(state.editing.playlistItem);
	    },
	    PLAYLISTITEM_READY: function PLAYLISTITEM_READY(state) {
	      state.editing.pending = false;
	    },
	    PENDING_PLAYLISTITEM: function PENDING_PLAYLISTITEM(state) {
	      state.editing.pending = true;
	    },
	    PLAYLIST_ITEMS_SELECT_FAILED: function PLAYLIST_ITEMS_SELECT_FAILED() {},
	    PLAYLIST_ITEMS_UPDATE: function PLAYLIST_ITEMS_UPDATE(state) {
	      state.editing.pending = true;
	    },
	    PLAYLIST_ITEMS_UPDATE_SUCCESS: function PLAYLIST_ITEMS_UPDATE_SUCCESS(state) {
	      state.editing.playlistItem = (0, _lodash.cloneDeep)(defaultPlaylistItem);
	      state.editing.pending = false;
	    },
	    PLAYLIST_ITEMS_UPDATE_FAILED: function PLAYLIST_ITEMS_UPDATE_FAILED(state, payload) {
	      state.editing.playlistItem = (0, _lodash.cloneDeep)(defaultPlaylistItem);
	      state.editing.pending = false;
	      state.editing.errors = payload;
	    },
	    PLAYLIST_ITEMS_SET: function PLAYLIST_ITEMS_SET(state, playlistItems) {
	      state.list.playlistItems = playlistItems;
	    },
	    SET_PLAYLISTITEM_CAPTION: function SET_PLAYLISTITEM_CAPTION(state, caption) {
	      state.editing.playlistItem.caption = caption;
	    },
	    SET_PLAYLISTITEM: function SET_PLAYLISTITEM(state, item) {
	      state.editing.playlistItem = item;
	    }
	  },
	  actions: {
	    refreshPlaylistItems: function refreshPlaylistItems(_ref2) {
	      var commit = _ref2.commit;
	
	      commit("PLAYLIST_ITEMS_LIST_CLEAN");
	    },
	    setPlayListItemCaption: function setPlayListItemCaption(_ref3, caption) {
	      var state = _ref3.state,
	          commit = _ref3.commit;
	
	      if (state.editing.playlistItem) commit("SET_PLAYLISTITEM_CAPTION", caption);
	    },
	    setPlaylistItem: function setPlaylistItem(_ref4, item) {
	      var commit = _ref4.commit;
	
	      commit("SET_PLAYLISTITEM", item);
	    },
	    loadMorePlaylistItems: function loadMorePlaylistItems(_ref5) {
	      var state = _ref5.state,
	          commit = _ref5.commit,
	          rootState = _ref5.rootState;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("PLAYLIST_ITEMS_LIST");
	        var _state$list = state.list,
	            nextPage = _state$list.nextPage,
	            pageSize = _state$list.pageSize,
	            filter = _state$list.filter;
	
	        return kithara.getPlaylistItems(rootState.route.params.playlistId, nextPage, pageSize, "position|asc", filter).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
	            playlistItems: state.list.playlistItems.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	        }).catch(function (err) {
	          return commit("PLAYLIST_ITEMS_LIST_FAILED", [err]);
	        });
	      }
	    },
	    loadAllPlaylistItems: function loadAllPlaylistItems(_ref6) {
	      var state = _ref6.state,
	          commit = _ref6.commit,
	          rootState = _ref6.rootState;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("PLAYLIST_ITEMS_LIST_CLEAN");var filter = state.list.filter;
	
	        return kithara.getPlaylistItems(rootState.route.params.playlistId, 1, -1, "position|asc", filter).then(function (response) {
	          var data = response.data.data;
	
	          commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
	            playlistItems: data,
	            complete: true
	          });
	        }).catch(function (err) {
	          return commit("PLAYLIST_ITEMS_LIST_FAILED", [err]);
	        });
	      }
	    },
	    setCurrentPlayListItem: function setCurrentPlayListItem(_ref7, item) {
	      var commit = _ref7.commit;
	
	      commit("PLAYLIST_ITEMS_SET_SELECTED", item);
	    },
	    fetchPlaylistItems: function fetchPlaylistItems(_ref8, playlistId) {
	      var state = _ref8.state,
	          commit = _ref8.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("PLAYLIST_ITEMS_LIST");
	        var _state$list2 = state.list,
	            nextPage = _state$list2.nextPage,
	            pageSize = _state$list2.pageSize,
	            filter = _state$list2.filter;
	
	        return kithara.getPlaylistItems(playlistId, nextPage, pageSize, "position|asc", filter).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
	            playlistItems: state.list.playlistItems.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	        }).catch(function (err) {
	          return commit("PLAYLIST_ITEMS_LIST_FAILED", [err]);
	        });
	      }
	    },
	    fetchPlayListItem: function fetchPlayListItem(_ref9, _ref10) {
	      var state = _ref9.state,
	          commit = _ref9.commit,
	          rootState = _ref9.rootState;
	      var playlistId = _ref10.playlistId,
	          itemId = _ref10.itemId;
	
	      if (itemId === state.editing.playlistItem.id) {
	        return state.editing.playlistItem;
	      }
	
	      commit("PENDING_PLAYLISTITEM");
	
	      var itemFromStore = rootState.playlistItems.list.playlistItems.find(function (item) {
	        return item.id === itemId;
	      });
	      if (itemFromStore) {
	        commit("SET_PLAYLISTITEM", itemFromStore);
	        commit("PLAYLISTITEM_READY");
	        return itemFromStore;
	      }
	
	      var _state$list3 = state.list,
	          nextPage = _state$list3.nextPage,
	          pageSize = _state$list3.pageSize,
	          filter = _state$list3.filter;
	
	      return kithara.getPlaylistItems(playlistId, nextPage, pageSize, "position|asc", filter).then(function (resp) {
	        var items = resp.data.data;
	        var expectedItem = items.find(function (item) {
	          return item.id == itemId;
	        });
	        var returnedItem = expectedItem ? expectedItem : {};
	        commit("SET_PLAYLISTITEM", returnedItem);
	        commit("PLAYLISTITEM_READY");
	        return returnedItem;
	      });
	    },
	    selectPlaylistItem: function selectPlaylistItem(_ref11) {
	      var state = _ref11.state,
	          commit = _ref11.commit,
	          rootState = _ref11.rootState,
	          dispatch = _ref11.dispatch;
	
	      return dispatch("loadAllPlaylistItems").then(function () {
	        commit("PLAYLIST_ITEMS_SELECT");
	        for (var i = 0; i < state.list.playlistItems.length; i++) {
	          if (state.list.playlistItems[i].id === parseInt(rootState.route.params.playlistItemId)) {
	            commit("PLAYLIST_ITEMS_SET_SELECTED", state.list.playlistItems[i]);
	            return;
	          }
	        }
	        commit("PLAYLIST_ITEMS_SELECT_FAILED", new Error("Could not find playlistItem with id " + rootState.route.params.playlistItemId));
	      });
	    },
	    createPlaylistItem: function createPlaylistItem(_ref12) {
	      var state = _ref12.state,
	          commit = _ref12.commit,
	          rootState = _ref12.rootState,
	          dispatch = _ref12.dispatch;
	
	      return dispatch("loadAllPlaylistItems").then(function () {
	        commit("PLAYLIST_ITEMS_UPDATE");
	        commit("PLAYLIST_ITEMS_ADD_SELECTED_TO_LIST");
	        return kithara.updatePlaylistItems(rootState.route.params.playlistId, state.list.playlistItems).then(function () {
	          commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
	          commit("PLAYLIST_ITEMS_LIST_CLEAN");
	        }).catch(function (err) {
	          return commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]);
	        });
	      });
	    },
	    savePlaylistItem: function savePlaylistItem(_ref13) {
	      var state = _ref13.state,
	          commit = _ref13.commit,
	          rootState = _ref13.rootState,
	          dispatch = _ref13.dispatch;
	
	      return dispatch("loadAllPlaylistItems").then(function () {
	        commit("PLAYLIST_ITEMS_UPDATE");
	        commit("PLAYLIST_ITEMS_UPDATE_SELECTED_IN_LIST");
	        return kithara.updatePlaylistItems(rootState.route.params.playlistId, state.list.playlistItems).then(function () {
	          commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
	          commit("PLAYLIST_ITEMS_LIST_CLEAN");
	        }).catch(function (err) {
	          return commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]);
	        });
	      });
	    },
	    updatePlaylistItem: function updatePlaylistItem(_ref14, payload) {
	      var commit = _ref14.commit;
	
	      commit("PLAYLIST_ITEMS_UPDATE_SELECTED", payload);
	    },
	    removePlaylistItem: function removePlaylistItem(_ref15, _ref16) {
	      var commit = _ref15.commit,
	          dispatch = _ref15.dispatch,
	          state = _ref15.state;
	      var playlistId = _ref16.playlistId,
	          playlistItemId = _ref16.playlistItemId;
	
	      var playlistItems = state.list.playlistItems.filter(function (elem) {
	        return elem.id != playlistItemId;
	      });
	      commit("PLAYLIST_ITEMS_UPDATE");
	      commit("PLAYLIST_ITEMS_SET", playlistItems);
	      return kithara.updatePlaylistItems(playlistId, playlistItems).then(function () {
	        commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
	      }).catch(function (err) {
	        commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]);
	        dispatch("refreshPlaylistItems");
	        dispatch("loadMorePlaylistItems");
	      });
	    },
	    updatePlaylisItemsOrder: function updatePlaylisItemsOrder(_ref17, playlistItems) {
	      var commit = _ref17.commit,
	          rootState = _ref17.rootState;
	
	      commit("PLAYLIST_ITEMS_UPDATE");
	      commit("PLAYLIST_ITEMS_SET", playlistItems);
	      return kithara.updatePlaylistItems(rootState.route.params.playlistId, playlistItems).then(function () {
	        commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
	      }).catch(function (err) {
	        return commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]);
	      });
	    }
	  },
	  getters: {
	    playlistItems: function playlistItems(state) {
	      return state.list.playlistItems;
	    },
	    playlistItemsLoading: function playlistItemsLoading(state) {
	      return state.list.loading;
	    },
	    playlistItemsComplete: function playlistItemsComplete(state) {
	      return state.list.complete;
	    },
	    selectedPlaylistItem: function selectedPlaylistItem(state) {
	      return state.editing.playlistItem;
	    },
	    selectedPlaylistItemTags: function selectedPlaylistItemTags(state) {
	      return state.editing.playlistItem.template_item ? state.editing.playlistItem.template_item.tags : [];
	    }
	  }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	var defaultPlaylist = {
	  name: ""
	};
	exports.default = {
	  state: {
	    list: {
	      loading: false,
	      complete: false,
	      errors: [],
	      playlists: [],
	      nextPage: 1,
	      pageSize: 40,
	      filter: ""
	    },
	    editing: {
	      pending: false,
	      errors: [],
	      playlist: (0, _lodash.cloneDeep)(defaultPlaylist)
	    }
	  },
	  mutations: {
	    PLAYLISTS_LIST_CLEAN: function PLAYLISTS_LIST_CLEAN(state) {
	      state.list.playlists = [];
	      state.list.nextPage = 1;
	      state.list.complete = false;
	    },
	    PLAYLISTS_CURRENT_CLEAR: function PLAYLISTS_CURRENT_CLEAR(state) {
	      state.editing.playlist = (0, _lodash.cloneDeep)(defaultPlaylist);
	      state.editing.errors = [];
	      state.editing.pending = false;
	    },
	    PLAYLISTS_LIST: function PLAYLISTS_LIST(state) {
	      state.list.loading = true;
	    },
	    PLAYLISTS_LIST_FILTER: function PLAYLISTS_LIST_FILTER(state, payload) {
	      state.list.filter = payload;
	    },
	    PLAYLISTS_LIST_SUCCESS: function PLAYLISTS_LIST_SUCCESS(state, payload) {
	      state.list.loading = false;
	      state.list.playlists = payload.playlists;
	      state.list.complete = payload.complete;
	      state.list.nextPage++;
	    },
	    PLAYLISTS_LIST_FAILED: function PLAYLISTS_LIST_FAILED(state, payload) {
	      state.list.loading = false;
	      state.list.errors = payload;
	    },
	    PLAYLISTS_SELECT: function PLAYLISTS_SELECT(state) {
	      state.editing.playlist = (0, _lodash.cloneDeep)(defaultPlaylist);
	    },
	    PLAYLISTS_SET_SELECTED: function PLAYLISTS_SET_SELECTED(state, payload) {
	      state.editing.playlist = payload;
	    },
	    PLAYLISTS_UPDATE_SELECTED: function PLAYLISTS_UPDATE_SELECTED(state, _ref) {
	      var path = _ref.path,
	          value = _ref.value;
	
	      (0, _lodash.set)(state.editing.playlist, path, value);
	    },
	    PLAYLIST_REMOVE_FIELD_SELECTED: function PLAYLIST_REMOVE_FIELD_SELECTED(state, _ref2) {
	      var path = _ref2.path;
	
	      delete state.editing.playlist[path];
	    },
	    PLAYLISTS_SELECT_FAILED: function PLAYLISTS_SELECT_FAILED() {},
	    PLAYLISTS_UPDATE: function PLAYLISTS_UPDATE(state) {
	      state.editing.pending = true;
	    },
	    PLAYLISTS_UPDATE_SUCCESS: function PLAYLISTS_UPDATE_SUCCESS(state) {
	      state.editing.pending = false;
	    },
	    PLAYLISTS_UPDATE_FAILED: function PLAYLISTS_UPDATE_FAILED(state, payload) {
	      state.editing.playlist = (0, _lodash.cloneDeep)(defaultPlaylist);
	      state.editing.pending = false;
	      state.editing.errors = payload;
	    },
	    PLAYLIST_SET_TEMPLATE_ID: function PLAYLIST_SET_TEMPLATE_ID(state, templateId) {
	      state.editing.playlist.template_id = templateId;
	    }
	  },
	  actions: {
	    setCurrentPlayList: function setCurrentPlayList(_ref3, playlist) {
	      var commit = _ref3.commit;
	
	      commit("PLAYLISTS_SET_SELECTED", playlist);
	    },
	    changePlaylistsFilter: function changePlaylistsFilter(_ref4, payload) {
	      var commit = _ref4.commit,
	          rootState = _ref4.rootState;
	
	      if (!payload) {
	        payload = rootState.route.query.filter;
	      }
	      commit("PLAYLISTS_LIST_FILTER", payload);
	    },
	    clearCurrentPlaylist: function clearCurrentPlaylist(_ref5) {
	      var commit = _ref5.commit;
	
	      commit("PLAYLISTS_CURRENT_CLEAR");
	    },
	    refreshPlaylists: function refreshPlaylists(_ref6) {
	      var commit = _ref6.commit;
	
	      commit("PLAYLISTS_LIST_CLEAN");
	    },
	    loadMorePlaylists: function loadMorePlaylists(_ref7) {
	      var state = _ref7.state,
	          commit = _ref7.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("PLAYLISTS_LIST");
	        var _state$list = state.list,
	            nextPage = _state$list.nextPage,
	            pageSize = _state$list.pageSize,
	            filter = _state$list.filter;
	
	        return kithara.getPlaylists(nextPage, pageSize, "name|asc", filter).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("PLAYLISTS_LIST_SUCCESS", {
	            playlists: state.list.playlists.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	        }).catch(function (err) {
	          return commit("PLAYLISTS_LIST_FAILED", [err]);
	        });
	      }
	    },
	    updatePlaylistElement: function updatePlaylistElement(_ref8, _ref9) {
	      var commit = _ref8.commit;
	      var path = _ref9.path,
	          value = _ref9.value;
	
	      value == null ? commit("PLAYLIST_REMOVE_FIELD_SELECTED", { path: path }) : commit("PLAYLISTS_UPDATE_SELECTED", { path: path, value: value });
	    },
	    fetchPlaylist: function fetchPlaylist(_ref10, playlistId) {
	      var state = _ref10.state,
	          commit = _ref10.commit,
	          rootState = _ref10.rootState;
	
	      if (playlistId === state.editing.playlist.id) {
	        return state.editing.playlist;
	      }
	      var playlistFromStore = rootState.playlists.list.playlists.find(function (item) {
	        return item.id === playlistId;
	      });
	      if (playlistFromStore) {
	        commit("PLAYLISTS_SET_SELECTED", playlistFromStore);
	        return playlistFromStore;
	      }
	      return kithara.getPlaylist(playlistId).then(function (resp) {
	        var playlistFromDb = resp.data;
	        commit("PLAYLISTS_SET_SELECTED", playlistFromDb);
	        return playlistFromDb;
	      });
	    },
	    selectPlaylist: function selectPlaylist(_ref11) {
	      var commit = _ref11.commit,
	          rootState = _ref11.rootState;
	
	      commit("PLAYLISTS_SELECT");
	      commit("PLAYLIST_ITEMS_LIST_CLEAN");
	      return kithara.getPlaylist(rootState.route.params.playlistId).then(function (response) {
	        commit("PLAYLISTS_SET_SELECTED", response.data);
	      }).catch(function (err) {
	        return commit("PLAYLISTS_SELECT_FAILED", [err]);
	      });
	    },
	    createPlaylist: function createPlaylist(_ref12) {
	      var state = _ref12.state,
	          commit = _ref12.commit;
	
	      commit("PLAYLISTS_UPDATE");
	      commit("PLAYLIST_ITEMS_LIST_CLEAN");
	      return kithara.createPlaylist(state.editing.playlist).then(function (response) {
	        commit("PLAYLISTS_UPDATE_SUCCESS");
	        commit("PLAYLISTS_LIST_CLEAN");
	        return response;
	      }).catch(function (err) {
	        return commit("PLAYLISTS_UPDATE_FAILED", [err]);
	      });
	    },
	    savePlaylist: function savePlaylist(_ref13) {
	      var state = _ref13.state,
	          commit = _ref13.commit,
	          rootState = _ref13.rootState;
	
	      commit("PLAYLISTS_UPDATE");
	      return kithara.updatePlaylist(rootState.route.params.playlistId, state.editing.playlist).then(function () {
	        commit("PLAYLISTS_UPDATE_SUCCESS");
	        commit("PLAYLISTS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("PLAYLISTS_UPDATE_FAILED", [err]);
	      });
	    },
	    deletePlaylist: function deletePlaylist(_ref14, _ref15) {
	      var commit = _ref14.commit;
	      var id = _ref15.id;
	
	      commit("PLAYLISTS_UPDATE");
	      return kithara.deletePlaylist(id).then(function (response) {
	        commit("PLAYLISTS_UPDATE_SUCCESS");
	        commit("PLAYLISTS_SELECT");
	        commit("PLAYLISTS_LIST_CLEAN");
	        return response;
	      }).catch(function (err) {
	        return commit("PLAYLISTS_UPDATE_FAILED", [err]);
	      });
	    }
	  },
	  getters: {
	    playlists: function playlists(state) {
	      return state.list.playlists;
	    },
	    playlistsFilter: function playlistsFilter(state) {
	      return state.list.filter;
	    },
	    playlistsLoading: function playlistsLoading(state) {
	      return state.list.loading;
	    },
	    playlistsComplete: function playlistsComplete(state) {
	      return state.list.complete;
	    },
	    selectedPlaylist: function selectedPlaylist(state) {
	      return state.editing.playlist;
	    }
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	exports.default = {
	  state: {
	    list: {
	      loading: false,
	      complete: false,
	      errors: [],
	      songs: [],
	      nextPage: 1,
	      pageSize: 40,
	      filters: {
	        main: "",
	        tags: []
	      }
	    },
	    editing: {
	      pending: false,
	      errors: [],
	      song: {}
	    }
	  },
	  mutations: {
	    SONGS_LIST_CLEAN: function SONGS_LIST_CLEAN(state) {
	      state.list.songs = [];
	      state.list.nextPage = 1;
	      state.list.complete = false;
	    },
	    SONGS_LIST: function SONGS_LIST(state) {
	      state.list.loading = true;
	    },
	    SONGS_LIST_FILTER: function SONGS_LIST_FILTER(state, payload) {
	      state.list.filters = payload;
	    },
	    SONGS_LIST_SUCCESS: function SONGS_LIST_SUCCESS(state, payload) {
	      state.list.loading = false;
	      state.list.songs = payload.songs;
	      state.list.complete = payload.complete;
	      state.list.nextPage++;
	    },
	    SONGS_LIST_FAILED: function SONGS_LIST_FAILED(state, payload) {
	      state.list.loading = false;
	      state.list.errors = payload;
	    },
	    SONGS_SELECT: function SONGS_SELECT(state) {
	      state.editing.song = {};
	    },
	    SONGS_SET_SELECTED: function SONGS_SET_SELECTED(state, payload) {
	      state.editing.song = payload;
	    },
	    SONGS_UPDATE_SELECTED: function SONGS_UPDATE_SELECTED(state, _ref) {
	      var path = _ref.path,
	          value = _ref.value;
	
	      (0, _lodash.set)(state.editing.song, path, value);
	    },
	    SONGS_SELECT_FAILED: function SONGS_SELECT_FAILED() {},
	    SONGS_UPDATE: function SONGS_UPDATE(state) {
	      state.editing.pending = true;
	    },
	    SONGS_UPDATE_SUCCESS: function SONGS_UPDATE_SUCCESS(state) {
	      state.editing.pending = false;
	    },
	    SONGS_UPDATE_FAILED: function SONGS_UPDATE_FAILED(state, payload) {
	      state.editing.pending = false;
	      state.editing.errors = payload;
	    }
	  },
	  actions: {
	    changeSongsFilter: function changeSongsFilter(_ref2, payload) {
	      var commit = _ref2.commit,
	          rootState = _ref2.rootState;
	
	      if (!payload) {
	        payload = { main: rootState.route.query.filter, tags: [] };
	      }
	      commit("SONGS_LIST_CLEAN");
	      commit("TEAM_SONGS_LIST_CLEAN");
	      commit("SONGS_LIST_FILTER", payload);
	      commit("TEAM_SONGS_LIST_FILTER", payload);
	    },
	    refreshSongs: function refreshSongs(_ref3) {
	      var commit = _ref3.commit;
	
	      commit("SONGS_LIST_CLEAN");
	    },
	    loadMoreSongs: function loadMoreSongs(_ref4) {
	      var state = _ref4.state,
	          commit = _ref4.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("SONGS_LIST");
	        var _state$list = state.list,
	            nextPage = _state$list.nextPage,
	            pageSize = _state$list.pageSize,
	            filters = _state$list.filters;
	
	        return kithara.getSongs(nextPage, pageSize, "title|asc", filters).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("SONGS_LIST_SUCCESS", {
	            songs: state.list.songs.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	          return data;
	        }).catch(function (err) {
	          return commit("SONGS_LIST_FAILED", [err]);
	        });
	      } else return [];
	    },
	    loadAllSongs: function loadAllSongs(_ref5) {
	      var state = _ref5.state,
	          commit = _ref5.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("SONGS_LIST");
	        var _state$list2 = state.list,
	            nextPage = _state$list2.nextPage,
	            filters = _state$list2.filters;
	
	        return kithara.getSongs(nextPage, -1, "title|asc", filters).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("SONGS_LIST_SUCCESS", {
	            songs: state.list.songs.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	          return data;
	        }).catch(function (err) {
	          return commit("SONGS_LIST_FAILED", [err]);
	        });
	      } else return [];
	    },
	    selectSong: function selectSong(_ref6) {
	      var commit = _ref6.commit,
	          rootState = _ref6.rootState;
	
	      commit("SONGS_SELECT");
	      return kithara.getSong(rootState.route.params.id).then(function (response) {
	        commit("SONGS_SET_SELECTED", response.data);
	      }).catch(function (err) {
	        return commit("SONGS_SELECT_FAILED", [err]);
	      });
	    },
	    clearSong: function clearSong(_ref7) {
	      var commit = _ref7.commit;
	
	      commit("SONGS_SELECT");
	    },
	    createSong: function createSong(_ref8) {
	      var state = _ref8.state,
	          commit = _ref8.commit;
	
	      commit("SONGS_UPDATE");
	      return kithara.createSong(state.editing.song).then(function () {
	        commit("SONGS_UPDATE_SUCCESS");
	        commit("SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    saveSong: function saveSong(_ref9) {
	      var state = _ref9.state,
	          commit = _ref9.commit,
	          rootState = _ref9.rootState;
	
	      commit("SONGS_UPDATE");
	      return kithara.updateSong(rootState.route.params.id, state.editing.song).then(function () {
	        commit("SONGS_UPDATE_SUCCESS");
	        commit("SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    deleteSong: function deleteSong(_ref10) {
	      var commit = _ref10.commit,
	          rootState = _ref10.rootState;
	
	      commit("SONGS_UPDATE");
	      return kithara.deleteSong(rootState.route.params.id).then(function () {
	        commit("SONGS_UPDATE_SUCCESS");
	        commit("SONGS_SELECT");
	        commit("SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    updateSelectedSong: function updateSelectedSong(_ref11, _ref12) {
	      var commit = _ref11.commit;
	      var path = _ref12.path,
	          value = _ref12.value;
	
	      commit("SONGS_UPDATE_SELECTED", { path: path, value: value });
	    }
	  },
	  getters: {
	    songs: function songs(state) {
	      return state.list.songs;
	    },
	    songsFilter: function songsFilter(state) {
	      return state.list.filters.main;
	    },
	    songsLoading: function songsLoading(state) {
	      return state.list.loading;
	    },
	    songsComplete: function songsComplete(state) {
	      return state.list.complete;
	    },
	    selectedSong: function selectedSong(state) {
	      return state.editing.song;
	    }
	  }
	};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _kithara = __webpack_require__(9);
	
	var _kithara2 = _interopRequireDefault(_kithara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kithara = new _kithara2.default();
	
	exports.default = {
	  state: {
	    list: {
	      loading: false,
	      complete: false,
	      errors: [],
	      teamSongs: [],
	      nextPage: 1,
	      pageSize: 40,
	      filters: {
	        main: "",
	        tags: []
	      }
	    },
	    editing: {
	      pending: false,
	      errors: [],
	      teamSong: {}
	    }
	  },
	  mutations: {
	    TEAM_SONGS_LIST_CLEAN: function TEAM_SONGS_LIST_CLEAN(state) {
	      state.list.teamSongs = [];
	      state.list.nextPage = 1;
	      state.list.complete = false;
	    },
	    TEAM_SONGS_LIST: function TEAM_SONGS_LIST(state) {
	      state.list.loading = true;
	    },
	    TEAM_SONGS_LIST_FILTER: function TEAM_SONGS_LIST_FILTER(state, payload) {
	      state.list.filters = payload;
	    },
	    TEAM_SONGS_LIST_SUCCESS: function TEAM_SONGS_LIST_SUCCESS(state, payload) {
	      state.list.loading = false;
	      state.list.teamSongs = payload.teamSongs;
	      state.list.complete = payload.complete;
	      state.list.nextPage++;
	    },
	    TEAM_SONGS_LIST_FAILED: function TEAM_SONGS_LIST_FAILED(state, payload) {
	      state.list.loading = false;
	      state.list.errors = payload;
	    },
	    TEAM_SONGS_SELECT: function TEAM_SONGS_SELECT(state) {
	      state.editing.teamSong = {};
	    },
	    TEAM_SONGS_SET_SELECTED: function TEAM_SONGS_SET_SELECTED(state, payload) {
	      state.editing.teamSong = payload;
	    },
	    TEAM_SONGS_UPDATE_SELECTED: function TEAM_SONGS_UPDATE_SELECTED(state, _ref) {
	      var path = _ref.path,
	          value = _ref.value;
	
	      (0, _lodash.set)(state.editing.teamSong, path, value);
	    },
	    TEAM_SONGS_SELECT_FAILED: function TEAM_SONGS_SELECT_FAILED() {},
	    TEAM_SONGS_UPDATE: function TEAM_SONGS_UPDATE(state) {
	      state.editing.pending = true;
	    },
	    TEAM_SONGS_UPDATE_SUCCESS: function TEAM_SONGS_UPDATE_SUCCESS(state) {
	      state.editing.pending = false;
	    },
	    TEAM_SONGS_UPDATE_FAILED: function TEAM_SONGS_UPDATE_FAILED(state, payload) {
	      state.editing.pending = false;
	      state.editing.errors = payload;
	    }
	  },
	  actions: {
	    changeTeamSongsFilter: function changeTeamSongsFilter(_ref2, payload) {
	      var commit = _ref2.commit,
	          rootState = _ref2.rootState;
	
	      if (!payload) {
	        payload = { main: rootState.route.query.filter, tags: [] };
	      }
	      commit("TEAM_SONGS_LIST_CLEAN");
	      commit("TEAM_SONGS_LIST_FILTER", payload);
	      commit("SONGS_LIST_CLEAN");
	      commit("SONGS_LIST_FILTER", payload);
	    },
	    refreshTeamSongs: function refreshTeamSongs(_ref3) {
	      var commit = _ref3.commit;
	
	      commit("TEAM_SONGS_LIST_CLEAN");
	    },
	    loadMoreTeamSongs: function loadMoreTeamSongs(_ref4) {
	      var state = _ref4.state,
	          commit = _ref4.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("TEAM_SONGS_LIST");
	        var _state$list = state.list,
	            nextPage = _state$list.nextPage,
	            pageSize = _state$list.pageSize,
	            filters = _state$list.filters;
	
	        return kithara.getTeamSongs(1, nextPage, pageSize, "title|asc", filters).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("TEAM_SONGS_LIST_SUCCESS", {
	            teamSongs: state.list.teamSongs.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	          return data;
	        }).catch(function (err) {
	          return commit("TEAM_SONGS_LIST_FAILED", [err]);
	        });
	      } else return [];
	    },
	    loadAllTeamSongs: function loadAllTeamSongs(_ref5) {
	      var state = _ref5.state,
	          commit = _ref5.commit;
	
	      if (!state.list.loading && !state.list.complete) {
	        commit("TEAM_SONGS_LIST");
	        var _state$list2 = state.list,
	            nextPage = _state$list2.nextPage,
	            filters = _state$list2.filters;
	
	        return kithara.getTeamSongs(1, nextPage, -1, "title|asc", filters).then(function (response) {
	          var data = response.data.data;
	
	          var lastPage = response.data.links.pagination.last_page;
	          commit("TEAM_SONGS_LIST_SUCCESS", {
	            teamSongs: state.list.teamSongs.concat(data),
	            complete: lastPage === 0 || nextPage === lastPage
	          });
	          return data;
	        }).catch(function (err) {
	          return commit("TEAM_SONGS_LIST_FAILED", [err]);
	        });
	      } else return [];
	    },
	    selectTeamSong: function selectTeamSong(_ref6) {
	      var commit = _ref6.commit,
	          rootState = _ref6.rootState;
	
	      commit("TEAM_SONGS_SELECT");
	      return kithara.getTeamSong(1, rootState.route.params.id).then(function (response) {
	        commit("TEAM_SONGS_SET_SELECTED", response.data);
	      }).catch(function (err) {
	        return commit("TEAM_SONGS_SELECT_FAILED", [err]);
	      });
	    },
	    clearTeamSong: function clearTeamSong(_ref7) {
	      var commit = _ref7.commit;
	
	      commit("TEAM_SONGS_SELECT");
	    },
	    createTeamSong: function createTeamSong(_ref8) {
	      var state = _ref8.state,
	          commit = _ref8.commit;
	
	      commit("TEAM_SONGS_UPDATE");
	      return kithara.createTeamSong(1, state.editing.teamSong).then(function () {
	        commit("TEAM_SONGS_UPDATE_SUCCESS");
	        commit("TEAM_SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("TEAM_SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    saveTeamSong: function saveTeamSong(_ref9) {
	      var state = _ref9.state,
	          commit = _ref9.commit,
	          rootState = _ref9.rootState;
	
	      commit("TEAM_SONGS_UPDATE");
	      return kithara.updateTeamSong(1, rootState.route.params.id, state.editing.teamSong).then(function () {
	        commit("TEAM_SONGS_UPDATE_SUCCESS");
	        commit("TEAM_SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("TEAM_SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    deleteTeamSong: function deleteTeamSong(_ref10) {
	      var commit = _ref10.commit,
	          rootState = _ref10.rootState;
	
	      commit("TEAM_SONGS_UPDATE");
	      return kithara.deleteTeamSong(1, rootState.route.params.id).then(function () {
	        commit("TEAM_SONGS_UPDATE_SUCCESS");
	        commit("TEAM_SONGS_SELECT");
	        commit("TEAM_SONGS_LIST_CLEAN");
	      }).catch(function (err) {
	        return commit("TEAM_SONGS_UPDATE_FAILED", [err]);
	      });
	    },
	    updateSelectedTeamSong: function updateSelectedTeamSong(_ref11, _ref12) {
	      var commit = _ref11.commit;
	      var path = _ref12.path,
	          value = _ref12.value;
	
	      commit("TEAM_SONGS_UPDATE_SELECTED", { path: path, value: value });
	    }
	  },
	  getters: {
	    teamSongs: function teamSongs(state) {
	      return state.list.teamSongs;
	    },
	    teamSongsFilter: function teamSongsFilter(state) {
	      return state.list.filters.main;
	    },
	    teamSongsLoading: function teamSongsLoading(state) {
	      return state.list.loading;
	    },
	    teamSongsComplete: function teamSongsComplete(state) {
	      return state.list.complete;
	    },
	    selectedTeamSong: function selectedTeamSong(state) {
	      return state.editing.teamSong;
	    }
	  }
	};

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(239)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(119),
	  /* template */
	  __webpack_require__(326),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(232)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(120),
	  /* template */
	  __webpack_require__(319),
	  /* scopeId */
	  "data-v-6b081427",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(236)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(121),
	  /* template */
	  __webpack_require__(323),
	  /* scopeId */
	  "data-v-874b5a98",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(231)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(125),
	  /* template */
	  __webpack_require__(318),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(225)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(126),
	  /* template */
	  __webpack_require__(312),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(235)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(128),
	  /* template */
	  __webpack_require__(322),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(237)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(324),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(240)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(327),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(234)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(131),
	  /* template */
	  __webpack_require__(321),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(228)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(132),
	  /* template */
	  __webpack_require__(315),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(222)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(133),
	  /* template */
	  __webpack_require__(309),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(241)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(328),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(238)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(325),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(227)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(136),
	  /* template */
	  __webpack_require__(314),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(226)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(137),
	  /* template */
	  __webpack_require__(313),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(224)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(138),
	  /* template */
	  __webpack_require__(311),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'songs'
	      }
	    }
	  }, [_vm._v("\n              Songs\n            ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v(_vm._s(_vm.song.title || "New"))])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('song-edit', {
	    attrs: {
	      "initial-song": _vm.song
	    },
	    on: {
	      "update": function($event) {
	        return _vm.updateSelectedSong($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('a', {
	    staticClass: "add button is-large is-warning",
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-medium"
	  }, [_c('i', {
	    staticClass: "fas fa-check"
	  })])
	}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.song.title),
	      expression: "song.title"
	    }],
	    staticClass: "input title",
	    attrs: {
	      "type": "text",
	      "placeholder": "Title"
	    },
	    domProps: {
	      "value": (_vm.song.title)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.song, "title", $event.target.value)
	      }, function($event) {
	        return _vm.update('title', $event.target.value)
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('b-taginput', {
	    attrs: {
	      "ellipsis": "",
	      "placeholder": "Add a tag",
	      "icon": "label",
	      "autocomplete": "",
	      "data": _vm.displayedTags,
	      "field": "name"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.update('song.tags', $event)
	      },
	      "typing": _vm.getFilteredTags
	    },
	    model: {
	      value: (_vm.song.song.tags),
	      callback: function($$v) {
	        _vm.$set(_vm.song.song, "tags", $$v)
	      },
	      expression: "song.song.tags"
	    }
	  })], 1), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.song.lyrics),
	      expression: "song.lyrics"
	    }, {
	      name: "autosize",
	      rawName: "v-autosize"
	    }],
	    staticClass: "textarea",
	    attrs: {
	      "placeholder": "Lyrics"
	    },
	    domProps: {
	      "value": (_vm.song.lyrics)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.song, "lyrics", $event.target.value)
	      }, function($event) {
	        return _vm.update('lyrics', $event.target.value)
	      }]
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "song-search hero is-primary"
	  }, [_c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "columns is-vcentered"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_c('p', {
	    staticClass: "control has-icons-left has-icons-right",
	    class: {
	      'is-loading': false
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search"
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        $event.preventDefault();
	        return _vm.clearFilter()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "icon is-small is-right clickable"
	  }, [(_vm.filter) ? _c('a', {
	    staticClass: "delete",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.clearFilter()
	      }
	    }
	  }) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "song-list"
	  }, [_c('div', {
	    staticClass: "table-container"
	  }, [_c('table', {
	    staticClass: "table is-fullwidth"
	  }, [_c('thead', {
	    staticClass: "container"
	  }, [(_vm.teamSongs.length) ? _c('tr', {
	    staticClass: "content"
	  }, [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Quality")]), _vm._v(" "), _vm._l((_vm.teamSongs[0].member_data), function(m) {
	    return _c('th', {
	      key: m.user.id
	    }, [_vm._v(_vm._s(m.user.name.split(' ').map(function (e) { return e[0]; }).join('')))])
	  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', {
	    staticClass: "container"
	  }, _vm._l((_vm.teamSongs), function(teamSong) {
	    return _c('tr', {
	      key: teamSong.id,
	      staticClass: "content song"
	    }, [_c('td', {
	      staticStyle: {
	        "text-transform": "uppercase"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showTeamSong(teamSong)
	        }
	      }
	    }, [_vm._v(_vm._s(teamSong.title))]), _vm._v(" "), _c('td', [_c('button', {
	      class: [
	        'button',
	        'is-inverted',
	        (teamSong.quality || teamSong.properties.quality) === 2 ?
	        'is-success' :
	        (teamSong.quality || teamSong.properties.quality) === 1 ?
	        'is-info' :
	        'is-danger'
	      ],
	      attrs: {
	        "disabled": ""
	      }
	    }, [_c('span', {
	      staticClass: "icon is-small"
	    }, [_c('i', {
	      class: {
	        fas: true,
	          'quality-unknown fa-eye-slash': (teamSong.quality || teamSong.properties.quality || 0) === 0,
	          'quality-need-review fa-eye': (teamSong.quality || teamSong.properties.quality) === 1,
	          'quality-certified fa-award': (teamSong.quality || teamSong.properties.quality) === 2
	      }
	    })])])]), _vm._v(" "), _vm._l((teamSong.member_data), function(m) {
	      return _c('td', {
	        key: m.user.id
	      }, [_c('button', {
	        staticClass: "button is-hovered",
	        class: {
	          'is-static': (m.knowledge || 0) === 0,
	          'is-danger': m.knowledge === 1,
	            'is-warning': m.knowledge === 2,
	            'is-success': m.knowledge === 3
	        },
	        attrs: {
	          "disabled": ""
	        }
	      }, [_vm._m(1, true)])])
	    })], 2)
	  }), 0)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small is-left"
	  }, [_c('i', {
	    staticClass: "fas fa-search"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fas fa-guitar"
	  })])
	}]}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "song-search"
	  }, [_c('b-field', {
	    staticClass: "song-search",
	    attrs: {
	      "label": "Find a song"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [(_vm.showTags) ? _c('div', {
	    staticClass: "input-group-element minor"
	  }, [_c('b-taginput', {
	    attrs: {
	      "data": _vm.availableTags,
	      "ellipsis": "",
	      "autocomplete": "",
	      "field": "name",
	      "icon": "label",
	      "placeholder": "Add a tag"
	    },
	    on: {
	      "typing": _vm.getFilteredTags,
	      "input": _vm.getAsyncSongs
	    },
	    model: {
	      value: (_vm.selectedTags),
	      callback: function($$v) {
	        _vm.selectedTags = $$v
	      },
	      expression: "selectedTags"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group-element",
	    class: _vm.showTags ? 'major' : 'alone'
	  }, [_c('b-autocomplete', {
	    attrs: {
	      "rounded": "",
	      "data": _vm.filteredSongs,
	      "placeholder": "e.g. Alleluia",
	      "field": "title",
	      "icon": "magnify",
	      "loading": _vm.isFetchingSongs,
	      "open-on-focus": true
	    },
	    on: {
	      "typing": _vm.getAsyncSongs,
	      "select": function($event) {
	        return _vm.$emit('selectSong', $event)
	      }
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("\n            No results found\n          ")])], 2)], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "song-search hero is-primary"
	  }, [_c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "columns is-vcentered"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_c('p', {
	    staticClass: "control has-icons-left has-icons-right",
	    class: {
	      'is-loading': false
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search"
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        $event.preventDefault();
	        return _vm.clearFilter()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "icon is-small is-right clickable"
	  }, [(_vm.filter) ? _c('a', {
	    staticClass: "delete",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.clearFilter()
	      }
	    }
	  }) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "song-list"
	  }, _vm._l((_vm.songs), function(song) {
	    return _c('div', {
	      key: song.id,
	      staticClass: "song is-fullwidth",
	      on: {
	        "click": function($event) {
	          return _vm.showSong(song)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [_c('p', {
	      staticClass: "list-element-title"
	    }, [_c('span', {
	      domProps: {
	        "textContent": _vm._s(song.title)
	      }
	    })])])])])
	  }), 0), _vm._v(" "), _c('BaseRouterRoundButton', {
	    attrs: {
	      "destination": _vm.addLink
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small is-left"
	  }, [_c('i', {
	    staticClass: "fas fa-search"
	  })])
	}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'songs'
	      }
	    }
	  }, [_vm._v("\n              Songs\n            ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v(_vm._s(_vm.song ? _vm.song.title : ""))])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [(_vm.song) ? _c('div', {
	    staticClass: "container"
	  }, [(_vm.editMode) ? _c('song-edit', {
	    attrs: {
	      "initial-song": _vm.song
	    },
	    on: {
	      "update": function($event) {
	        return _vm.updateSelectedSong($event)
	      }
	    }
	  }) : _c('div', [(_vm.wakeLockAvailable()) ? _c('button', {
	    staticClass: "button",
	    class: [_vm.isWakeLocked ? 'is-active' : ''],
	    staticStyle: {
	      "display": "inline-block"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleWakeLock()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa-lightbulb",
	    class: [_vm.isWakeLocked ? 'fas' : 'far']
	  })])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    class: _vm.knowledgeClassObject,
	    staticStyle: {
	      "display": "inline-block"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeKnowledge()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fas fa-guitar"
	  })])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block",
	      "margin-bottom": "1.5em"
	    }
	  }, [_c('div', {
	    staticClass: "buttons has-addons"
	  }, [_c('button', {
	    staticClass: "button",
	    class: [_vm.format === 'chords' ? 'is-static' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setFormatter('chords')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fas fa-poll-h"
	  })]), _vm._v(" "), _c('span', [_vm._v("Text and chords")])]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    class: [_vm.format === 'text' ? 'is-static' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setFormatter('text')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fas fa-align-left"
	  })]), _vm._v(" "), _c('span', [_vm._v("Text only")])])])]), _vm._v(" "), (_vm.song.title) ? _c('div', [_c('h1', {
	    staticClass: "title",
	    staticStyle: {
	      "display": "inline-block",
	      "margin-bottom": "1.5rem",
	      "margin-right": "0.5rem"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.song.title) + "\n          ")]), _vm._v(" "), _c('button', {
	    class: [
	      'button',
	      'is-inverted',
	      _vm.quality === 2 ?
	      'is-success' :
	      _vm.quality === 1 ?
	      'is-info' :
	      'is-danger'
	    ],
	    on: {
	      "click": function($event) {
	        return _vm.changeQuality()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    class: _vm.qualityClassObject
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.song.properties && _vm.song.properties.couvent_index) ? _c('h2', {
	    staticClass: "subtitle has-text-grey-light",
	    staticStyle: {
	      "margin-top": "-1.25rem"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.song.properties.couvent_index) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.song.song) ? _c('div', {
	    staticClass: "song-tags"
	  }, [_c('div', {
	    staticClass: "field is-grouped is-grouped-multiline"
	  }, _vm._l((_vm.song.song.tags), function(tag) {
	    return _c('div', {
	      key: tag.id,
	      staticClass: "control"
	    }, [_c('div', {
	      staticClass: "tags has-addons"
	    }, [_c('a', {
	      staticClass: "tag is-link"
	    }, [_vm._v(_vm._s(tag.name))])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "lyrics",
	    class: 'format-' + _vm.format,
	    domProps: {
	      "innerHTML": _vm._s(_vm.songHTML)
	    }
	  })]), _vm._v(" "), (_vm.editMode) ? _c('a', {
	    staticClass: "button is-info",
	    on: {
	      "click": function($event) {
	        return _vm.remove()
	      }
	    }
	  }, [_c('span', [_vm._v("Delete")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('a', {
	    staticClass: "add button is-large is-warning",
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdit()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-medium"
	  }, [(_vm.editMode) ? _c('i', {
	    staticClass: "fas fa-check"
	  }) : _c('i', {
	    staticClass: "fas fa-pencil-alt"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'playlists'
	      }
	    }
	  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v(_vm._s("New"))])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h1', [_vm._v("New song for " + _vm._s(_vm.playlist.name))])]), _vm._v(" "), _c('playlist-item-edit')], 1)]), _vm._v(" "), _c('a', {
	    staticClass: "add button is-large is-warning",
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-medium"
	  }, [_c('i', {
	    staticClass: "fas fa-check"
	  })])
	}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('input', {
	    staticClass: "input title",
	    attrs: {
	      "type": "text",
	      "placeholder": "Name"
	    },
	    domProps: {
	      "value": _vm.playlist.name
	    },
	    on: {
	      "input": function($event) {
	        return _vm.updateName($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (!_vm.playlist || !_vm.playlist.id) ? _c('b-field', {
	    attrs: {
	      "label": "Create from template :"
	    }
	  }, [_c('b-autocomplete', {
	    attrs: {
	      "rounded": "",
	      "open-on-focus": true,
	      "data": _vm.filteredTemplates,
	      "placeholder": "Template name",
	      "icon": "magnify",
	      "field": "name"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.updateTemplate($event)
	      }
	    },
	    model: {
	      value: (_vm.templateName),
	      callback: function($$v) {
	        _vm.templateName = $$v
	      },
	      expression: "templateName"
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("\n        No results for " + _vm._s(_vm.templateName) + "\n      ")])], 2)], 1) : _c('div', [_c('draggable-playlist-items', {
	    attrs: {
	      "has-delete": true,
	      "draggable": true
	    },
	    on: {
	      "deleteItem": function($event) {
	        return _vm.handleRemovePlaylistItem($event)
	      },
	      "itemClick": function($event) {
	        return _vm.editPlaylistItem(_vm.playlist, $event)
	      }
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "button is-info",
	    attrs: {
	      "to": {
	        path: '/playlists/' + _vm.playlist.id + '/new-item'
	      }
	    }
	  }, [_c('span', [_vm._v("+")])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item-list"
	  }, [_c('draggable', _vm._b({
	    staticClass: "item-list",
	    attrs: {
	      "tag": "div",
	      "handle": ".handle",
	      "disabled": !_vm.draggable
	    },
	    on: {
	      "start": function($event) {
	        _vm.drag = true
	      },
	      "end": function($event) {
	        _vm.drag = false
	      }
	    },
	    model: {
	      value: (_vm.locPlaylistItems),
	      callback: function($$v) {
	        _vm.locPlaylistItems = $$v
	      },
	      expression: "locPlaylistItems"
	    }
	  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": !_vm.drag ? 'flip-list' : null
	    }
	  }, _vm._l((_vm.locPlaylistItems), function(item) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "item is-fullwidth"
	    }, [_c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [_c('i', {
	      staticClass: "fas fa-grip-vertical handle"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "item-info",
	      on: {
	        "click": function($event) {
	          return _vm.$emit('itemClick', item)
	        }
	      }
	    }, [_c('span', {
	      domProps: {
	        "textContent": _vm._s(_vm.getCaption(item))
	      }
	    }), _vm._v(" "), _c('span', {
	      domProps: {
	        "textContent": _vm._s(item.song_version ? item.song_version.title : '?')
	      }
	    })]), _vm._v(" "), (_vm.hasDelete) ? _c('i', {
	      staticClass: "fas fa-trash right red action",
	      on: {
	        "click": function($event) {
	          return _vm.$emit('deleteItem', item)
	        }
	      }
	    }) : _vm._e()])])])
	  }), 0)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "section"
	  }, [(_vm.playlist) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v("\n          " + _vm._s(_vm.playlist.name) + "\n        ")]), _vm._v(" "), _c('h2', {
	    staticClass: "subTitle"
	  }, [_vm._v("\n          " + _vm._s("items:") + "\n        ")]), _vm._v(" "), _c('draggable-playlist-items', {
	    on: {
	      "itemClick": function($event) {
	        return _vm.showPlaylistItem($event)
	      }
	    }
	  })], 1)]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "add button is-large is-warning",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('click')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-medium"
	  }, [_c('i', {
	    class: _vm.iconClass
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('input', {
	    staticClass: "input title",
	    attrs: {
	      "type": "text",
	      "placeholder": "Caption"
	    },
	    domProps: {
	      "value": _vm.getCaption()
	    },
	    on: {
	      "input": function($event) {
	        return _vm.update('caption', $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "subTitle"
	  }, [_c('b', [_vm._v("Song:")]), _vm._v("\n    " + _vm._s(_vm.playlistItem.song_version ? _vm.playlistItem.song_version.title : "?") + "\n  ")]), _vm._v(" "), _c('search-song', {
	    attrs: {
	      "show-tags": true,
	      "initial-tags": _vm.songTags
	    },
	    on: {
	      "selectSong": function($event) {
	        return _vm.update('song_version', $event)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'playlists'
	      }
	    }
	  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('playlist-edit', {
	    on: {
	      "update": function($event) {
	        return _vm.updatePlaylistElement($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('BaseActionRoundButton', {
	    attrs: {
	      "icon-class": _vm.buttonActionIconClass
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v("New")])])
	}]}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'playlists'
	      }
	    }
	  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.playlistItem.caption || "New") + "\n            ")])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('playlist-item-edit')], 1)]), _vm._v(" "), _c('BaseActionRoundButton', {
	    attrs: {
	      "icon-class": _vm.buttonActionIconClass
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "add button is-large is-warning",
	    attrs: {
	      "to": {
	        name: _vm.destination
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-medium"
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app"
	  }, [_c('nav', {
	    staticClass: "navbar is-light is-fixed-top"
	  }, [_c('div', {
	    staticClass: "bd-special-shadow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "navbar-brand"
	  }, [_c('router-link', {
	    staticClass: "navbar-item",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/kithara.svg",
	      "alt": "Kithara",
	      "width": "112",
	      "height": "28"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-burger burger",
	    class: {
	      'is-active': _vm.navbarShown
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleNavbar()
	      }
	    }
	  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
	    staticClass: "navbar-menu",
	    class: {
	      'is-active': _vm.navbarShown
	    }
	  }, [_c('div', {
	    staticClass: "navbar-start"
	  }, [_c('router-link', {
	    staticClass: "navbar-item",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNavbar(false)
	      }
	    }
	  }, [_vm._v("\n            Home\n          ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-item",
	    attrs: {
	      "to": {
	        name: 'table'
	      }
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNavbar(false)
	      }
	    }
	  }, [_vm._v("\n            Table\n          ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-item",
	    attrs: {
	      "to": {
	        name: 'playlists'
	      }
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNavbar(false)
	      }
	    }
	  }, [_vm._v("\n            Playlists\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "navbar-end"
	  }, [_c('div', {
	    staticClass: "navbar-item"
	  }, [_c('div', {
	    staticClass: "field is-grouped is-grouped-multiline"
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('a', {
	    staticClass: "button is-info",
	    on: {
	      "click": function($event) {
	        return _vm.download()
	      }
	    }
	  }, [_c('span', [_vm._v("Export")])]), _vm._v(" "), _c('a', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        return _vm.logout()
	      }
	    }
	  }, [_c('span', [_vm._v("Logout")])])])])])])])])]), _vm._v(" "), _c('router-view', {
	    staticClass: "router-view",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNavbar(false)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "playlist-search hero is-primary"
	  }, [_c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "columns is-vcentered"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_c('p', {
	    staticClass: "control has-icons-left has-icons-right",
	    class: {
	      'is-loading': false
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search"
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        $event.preventDefault();
	        return _vm.clearFilter()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "icon is-small is-right clickable"
	  }, [(_vm.filter) ? _c('a', {
	    staticClass: "delete",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.clearFilter()
	      }
	    }
	  }) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "playlist-list"
	  }, _vm._l((_vm.playlists), function(playlist) {
	    return _c('div', {
	      key: playlist.id,
	      staticClass: "playlist is-fullwidth",
	      on: {
	        "click": function($event) {
	          return _vm.showPlaylist(playlist)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [_c('p', {
	      staticClass: "list-element-title"
	    }, [_c('span', {
	      domProps: {
	        "textContent": _vm._s(playlist.name)
	      }
	    })])])])])
	  }), 0), _vm._v(" "), _c('BaseRouterRoundButton', {
	    attrs: {
	      "destination": _vm.addLink
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small is-left"
	  }, [_c('i', {
	    staticClass: "fas fa-search"
	  })])
	}]}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "root"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-form"
	  }, [_c('div', {
	    staticClass: "login-card"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [(!_vm.error && _vm.$route.query.redirect) ? _c('article', {
	    staticClass: "message is-info"
	  }, [_c('div', {
	    staticClass: "message-body"
	  }, [_vm._v("\n          You need to login first.\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('article', {
	    staticClass: "message is-danger"
	  }, [_c('div', {
	    staticClass: "message-body"
	  }, [_vm._v("\n          Error: " + _vm._s(_vm.error) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.login($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.username),
	      expression: "credentials.username"
	    }],
	    attrs: {
	      "placeholder": "Username",
	      "type": "text",
	      "required": "",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "username", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    attrs: {
	      "placeholder": "Password",
	      "type": "password",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n          Login\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-title"
	  }, [_c('h1', [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/kithara.svg",
	      "alt": "Kithara",
	      "width": "112",
	      "height": "28"
	    }
	  })])])])
	}]}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-primary"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "breadcrumb is-small",
	    attrs: {
	      "aria-label": "breadcrumbs"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'playlists'
	      }
	    }
	  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "is-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "aria-current": "page"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.playlist ? _vm.playlist.name : "") + "\n            ")])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section"
	  }, [(_vm.playlist) ? _c('div', {
	    staticClass: "container"
	  }, [(_vm.editMode) ? _c('playlist-edit', {
	    attrs: {
	      "initial-playlist": _vm.playlist,
	      "initial-playlist-items": _vm.playlistItems
	    },
	    on: {
	      "update": function($event) {
	        return _vm.updatePlaylistElement($event)
	      }
	    }
	  }) : _c('playlist-show'), _vm._v(" "), (_vm.editMode) ? _c('a', {
	    staticClass: "button is-info",
	    on: {
	      "click": function($event) {
	        return _vm.deleteThisPlaylist()
	      }
	    }
	  }, [_c('span', [_vm._v("Delete")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('a', {
	    staticClass: "add button is-large is-warning",
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdit()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon is-medium"
	  }, [(_vm.editMode) ? _c('i', {
	    staticClass: "fas fa-check"
	  }) : _c('i', {
	    staticClass: "fas fa-pencil-alt"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./BaseActionRoundButton.vue": 294,
		"./BaseRouterRoundButton.vue": 295
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 334;


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.d869abca6398b7519b09.js